<div id="approvalForm" *ngIf="sparDataLoaded" style="height: auto">
  <div
    *ngIf="showErrorsDisclaimer"
    id="errorDisclaimerID"
    style="margin-top: 2.625rem"
    class="errorDisclaimer"
  >
    <img src="assets/error.svg" />
    <span>
      There are errors on the form. Please fix the errors in order to continue.
    </span>
  </div>

  <div
    *ngIf="showMaterialHardwareOnlyErrorDisclaimer"
    style="margin-top: 2.625rem"
    id="materialHardwareErrorDisclaimerID"
    class="errorDisclaimer"
  >
    <img src="assets/error.svg" />
    <span>
      A Hardware Only form must have at least one row in the materials section
      that is a CAP row. Please add a CAP material record to continue.
    </span>
  </div>
  <div
    *ngIf="showMaterialHardwareSoftwareErrorDisclaimer"
    style="margin-top: 2.625rem"
    id="materialHardwareErrorDisclaimerID"
    class="errorDisclaimer"
  >
    <img src="assets/error.svg" />
    <span>
      A Hardware and Software form needs at least one row in the Materials
      section that is a Hardware CAP row, and at least one row additional row in
      either the Materials or Labor section that is a Software CAP row.
    </span>
  </div>
  <div
    *ngIf="showMaterialSoftwareOnlyErrorDisclaimer"
    style="margin-top: 2.625rem"
    id="materialSoftwareErrorDisclaimerID"
    class="errorDisclaimer"
  >
    <img src="assets/error.svg" />
    <span>
      A Software Only form must have at least one CAP row in either the
      Materials or Labor section. Please add a CAP material or CAP labor record
      to continue.
    </span>
  </div>
  <div
    *ngIf="showMaterialOmOnlyErrorDisclaimer"
    style="margin-top: 2.625rem"
    id="materialOmOnlyErrorDisclaimerID"
    class="errorDisclaimer"
  >
    <img src="assets/error.svg" />
    <span>
      An O&M form must have at least one row in either the Materials or Labor
      section. Please add a material or labor record to continue.
    </span>
  </div>
  <div
    *ngIf="showDerivationError"
    style="margin-top: 2.625rem"
    id="derivationErrorID"
    class="errorDisclaimer"
  >
    <img src="assets/error.svg" />
    <span>
      Config corrections are needed before form can be approved. See specific messages in red below that indicate corrections are required before proceeding.
    </span>
  </div>
  <div
    style="display: inline-block; width: 60%; margin-left: 4%; margin-top: 2.625rem"
  >
    <div class="form-status-container">
      <div class="form-status-column">
        <span
          *ngIf="displayRevisionNumber === 0"
          class="itProjectHeader"
          style="font-size: 1.313rem"
          >Form #{{ formNumber }}</span
        >
        <span
          *ngIf="displayRevisionNumber > 0"
          class="itProjectHeader"
          style="font-size: 1.313rem"
          >Form #{{ formNumber }}, Rev {{ displayRevisionNumber }}</span
        >
      </div>
      <div class="form-status-column p-0">
        <span
          *ngIf="formStatus === 'ET&S PAC Review'"
          style="width: 9rem"
          class="form-status text-grey"
          >ITPAC Review</span
        >

        <span
          *ngIf="formStatus === 'Lead ET&S PAC Review'"
          style="width: 9.125rem"
          class="form-status text-grey"
          >Lead ITPAC Review</span
        >

        <span
          *ngIf="formStatus === 'Asset Accounting Review'"
          style="width: 11.875rem"
          class="form-status text-grey"
          >Asset Accounting Review</span
        >

        <span
          *ngIf="formStatus === 'IT Sponsor Review'"
          style="width: 9rem"
          class="form-status text-grey"
          >Sponsor Review</span
        >

        <span
          *ngIf="formStatus === 'Joint Owner Review'"
          style="width: 9.125rem"
          class="form-status text-grey"
          >Joint Owner Review</span
        >

        <span
          *ngIf="formStatus.startsWith('DOA Review')"
          style="width: 6.688rem"
          class="form-status text-grey"
          >DOA Review</span
        >

        <div
          *ngIf="formStatus === 'Approved'"
          style="
            display: inline-block;
            margin-left: 1rem;
            background: #00853f 0% 0% no-repeat padding-box;
            border-radius: 8px;
            opacity: 1;
            width: 5.75rem;
            text-align: center;
            border: 1px solid #00853f;
          "
        >
          <span style="color: #ffffff; font-size: 0.875rem">Approved</span>
        </div>
        <div
          *ngIf="formStatus === 'Approved, Rejected by Joint Owners'"
          style="
            display: inline-block;
            margin-left: 1rem;
            background: #00853f 0% 0% no-repeat padding-box;
            border-radius: 8px;
            opacity: 1;
            width: 14.75rem;
            text-align: center;
            border: 1px solid #00853f;
          "
        >
          <span style="color: #ffffff; font-size: 0.875rem"
            >Approved, Rejected by Joint Owners</span
          >
        </div>
        <div
          *ngIf="formStatus === 'Completed'"
          style="
            display: inline-block;
            margin-left: 1rem;
            background: #696969 0% 0% no-repeat padding-box;
            border-radius: 8px;
            opacity: 1;
            width: 6.25rem;
            text-align: center;
            border: 1px solid #696969;
          "
        >
          <span style="color: #ffffff; font-size: 0.875rem">Completed</span>
        </div>
        <div
          *ngIf="formStatus === 'Completed, Rejected by Joint Owners'"
          style="
            display: inline-block;
            margin-left: 1rem;
            background: #696969 0% 0% no-repeat padding-box;
            border-radius: 8px;
            opacity: 1;
            width: 15.25rem;
            text-align: center;
            border: 1px solid #696969;
          "
        >
          <span style="color: #ffffff; font-size: 0.875rem"
            >Completed, Rejected by Joint Owners</span
          >
        </div>
        <div
          *ngIf="formStatus === 'Rejected'"
          style="
            display: inline-block;
            margin-left: 1rem;
            background: #ffffff 0% 0% no-repeat padding-box;
            border-radius: 8px;
            opacity: 1;
            width: 5.375rem;
            text-align: center;
            border: 1px solid #9e1b32;
          "
        >
          <span style="color: #9e1b32; font-size: 0.875rem">Rejected</span>
        </div>
      </div>

      <div
        class="form-status-column-right"
        [class.activityClosed]="!formActivityVisible"
        style="display: inline-block; float: right"
      >
        <button
          [matMenuTriggerFor]="menu"
          *ngIf="!editFormMode"
          class="action-button"
          matTooltip="Actions"
        >
          <mat-icon style="color: rgb(0, 120, 158)">more_vert</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
          <button mat-menu-item *ngIf="!editFormMode" (click)="generatePDF()">
            <span>Print Form</span>
          </button>
          <button
            mat-menu-item
            *ngIf="
              !editFormMode &&
              canEditForm()
            "
            (click)="toggleEditFormMode()"
          >
            <span>Edit Form</span>
          </button>
          <button
            mat-menu-item
            *ngIf="
              !editFormMode &&
              !(formCompleted() || youCompleted()) &&
              (isFormOwner() || isPACUser())
            "
            (click)="openDeleteConfirmationDialog()"
          >
            <span>Delete Form</span>
          </button>
        </mat-menu>
        <button
          *ngIf="editFormMode"
          (click)="saveForm(projectSetupForm, projectEstimateForm)"
          class="confirmButton"
          style="width: 8.125rem; margin-right: 0.938rem"
          type="submit"
        >
          <span class="confirmText">SAVE FORM</span>
        </button>
        <div
          *ngIf="editFormMode"
          (click)="cancelEdit()"
          class="exitButton"
          style="width: 5.125rem; margin-right: 0.938rem"
        >
          <span class="exitText">CANCEL</span>
        </div>
        <div
          *ngIf="youCompleted() || formCompleted()"
          (click)="
            !canCreateRevisionFromCurrentView()
              ? goToLatestRevisionInProgress()
              : createRevision()
          "
          class="exitButton"
          style="margin-right: 0.938rem; width: 16rem"
        >
          <span class="exitText">{{
            !canCreateRevisionFromCurrentView()
              ? hasOpenRevisionDraft
                ? 'Revision In Progress - View Current'
                : 'View Revision'
              : 'Create Revision'
          }}</span>
        </div>
        <div class="exitButton" (click)="toggleFormActivity()">
          <span class="exitText">ACTIVITY</span>
        </div>
      </div>
    </div>

    <div *ngIf="formNumbersRunningOut()" style="width: 35.5rem; color: darkred">
      <span style="font-size: 0.75rem"
        >PaTI ID {{ patiProject.Project_ID }} is within 10 of running out of
        numbers to assign to an ARF form. Please create a replacement and be
        sure the description is identical. (Otherwise users will be able to keep
        choosing this one.)</span
      >
    </div>
    <div
      [class.activityClosedBorder]="!formActivityVisible"
      style="
        height: 0.1rem;
        background-color: #f5f5f5;
        margin-top: 2.063rem;
        margin-left: -4rem;
      "
    ></div>
    <div *ngIf="isPACUser()" style="margin-top: 2.625rem">
      <span class="itProjectHeader" style="font-size: 1.313rem"
        >Form Admin</span
      >
    </div>
    <div *ngIf="isPACUser()" style="margin-bottom: 0.2rem">
      <div
        style="
          display: inline-block;
          margin-right: 7.25rem;
          white-space: nowrap;
        "
      >
        <span class="headerText">Form Owner</span>
      </div>
      <div
        style="
          display: inline-block;
          margin-right: 3.375rem;
          white-space: nowrap;
        "
      >
        <span class="headerText">ITPAC Assignment</span>
      </div>
      <div
        *ngIf="!(youCompleted() || formCompleted())"
        style="display: inline-block; white-space: nowrap"
      >
        <span class="headerText">Current Assignment</span>
      </div>
    </div>
    <div *ngIf="isPACUser() && !(youCompleted() || formCompleted()) || (editFormMode && formStatus === 'Rejected')">
      <div style="display: inline-block; width: 12.145rem">
        <span
          *ngIf="formOwner && formOwner.givenName && formOwner.surname"
          (click)="launchAssignmentDialog()"
          class="subHeaderText"
          style="cursor: pointer"
          >{{ formOwner.givenName }} {{ formOwner.surname }}</span
        >
        <span
          *ngIf="formOwner && !(formOwner.givenName && formOwner.surname)"
          (click)="launchAssignmentDialog()"
          class="subHeaderText"
          style="cursor: pointer"
          >{{ formOwner.displayName }}</span
        >
        <img
          (click)="launchAssignmentDialog()"
          style="width: 1rem; margin-left: 0.2rem; cursor: pointer"
          src="assets/review-edit.svg"
        />
      </div>
      <div style="display: inline-block; width: 10.61rem">
        <span
          *ngIf="
            etsPacAssignment &&
            etsPacAssignment.givenName &&
            etsPacAssignment.surname
          "
          (click)="launchAssignmentDialog()"
          class="subHeaderText"
          style="cursor: pointer"
          >{{ etsPacAssignment.givenName }} {{ etsPacAssignment.surname }}</span
        >
        <span
          *ngIf="
            etsPacAssignment &&
            !(etsPacAssignment.givenName && etsPacAssignment.surname)
          "
          (click)="launchAssignmentDialog()"
          class="subHeaderText"
          style="cursor: pointer"
          >{{ etsPacAssignment.displayName }}</span
        >
        <img
          (click)="launchAssignmentDialog()"
          style="width: 1rem; margin-left: 0.2rem; cursor: pointer"
          src="assets/review-edit.svg"
        />
      </div>
      <div style="display: inline-block; width: 12.313rem">
        <span
          *ngIf="
            currentAssignment &&
            currentAssignment.givenName &&
            currentAssignment.surname
          "
          (click)="launchAssignmentDialog()"
          class="subHeaderText"
          style="cursor: pointer"
          >{{ currentAssignment.givenName }}
          {{ currentAssignment.surname }}</span
        >
        <span
          *ngIf="
            currentAssignment &&
            !(currentAssignment.givenName && currentAssignment.surname)
          "
          (click)="launchAssignmentDialog()"
          class="subHeaderText"
          style="cursor: pointer"
          >{{ currentAssignment.displayName }}</span
        >
        <img
          (click)="launchAssignmentDialog()"
          style="width: 1rem; margin-left: 0.2rem; cursor: pointer"
          src="assets/review-edit.svg"
        />
      </div>
      <div style="display: inline-block; width: 30rem">
        <img
          (click)="launchApproverDialog()"
          style="cursor: pointer; width: 1.125rem; margin-right: 0.125rem"
          src="assets/manage-approvers.svg"
        />
        <span
          (click)="launchApproverDialog()"
          class="subHeaderText"
          style="cursor: pointer; white-space: nowrap"
          >Manage DOA Approvers</span
        >
      </div>
    </div>
    <div *ngIf="isPACUser() && (youCompleted() || formCompleted())">
      <div style="display: inline-block; width: 12.145rem">
        <span
          *ngIf="formOwner && formOwner.givenName && formOwner.surname"
          class="subHeaderText"
          style="color: #4c4c4c; text-decoration: none"
          >{{ formOwner.givenName }} {{ formOwner.surname }}</span
        >
        <span
          *ngIf="formOwner && !(formOwner.givenName && formOwner.surname)"
          class="subHeaderText"
          style="color: #4c4c4c; text-decoration: none"
          >{{ formOwner.displayName }}</span
        >
      </div>
      <div style="display: inline-block; width: 10.61rem">
        <span
          *ngIf="
            etsPacAssignment &&
            etsPacAssignment.givenName &&
            etsPacAssignment.surname
          "
          class="subHeaderText"
          style="color: #4c4c4c; text-decoration: none"
          >{{ etsPacAssignment.givenName }} {{ etsPacAssignment.surname }}</span
        >
        <span
          *ngIf="
            etsPacAssignment &&
            !(etsPacAssignment.givenName && etsPacAssignment.surname)
          "
          class="subHeaderText"
          style="color: #4c4c4c; text-decoration: none"
          >{{ etsPacAssignment.displayName }}</span
        >
      </div>
      <div style="display: inline-block; width: 12.313rem">
        <span
          *ngIf="
            currentAssignment &&
            currentAssignment.givenName &&
            currentAssignment.surname
          "
          class="subHeaderText"
          style="color: #4c4c4c; text-decoration: none"
          >{{ currentAssignment.givenName }}
          {{ currentAssignment.surname }}</span
        >
        <span
          *ngIf="
            currentAssignment &&
            !(currentAssignment.givenName && currentAssignment.surname)
          "
          class="subHeaderText"
          style="color: #4c4c4c; text-decoration: none"
          >{{ currentAssignment.displayName }}</span
        >
      </div>
    </div>
    <div *ngIf="tables" style="margin-top: 2.625rem">
      <span class="itProjectHeader" style="font-size: 1.313rem"
        >Notes from ITPAC</span
      >
    </div>
    <section id="tableSection" *ngIf="tables" class="content_container">
      <div class="effective_date_picker">
        <span class="effectiveDateText">Effective Date</span>
        <mat-form-field>
          <input
            matInput
            [matDatepicker]="effectiveDatePicker"
            [(ngModel)]="effectiveDate"
            style="color: #696969"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="effectiveDatePicker"
          ></mat-datepicker-toggle>
          <mat-datepicker #effectiveDatePicker></mat-datepicker>
        </mat-form-field>
      </div>

      <div
        class="table_container"
        *ngFor="let table of tables; let tableIndex = index"
      >
        <input
          matInput
          class="table_name_input"
          placeholder="Table Name"
          [value]="tables[tableIndex].tableName"
        />
        <div class="table_wrapper">
          <table mat-table [dataSource]="table.tableData" class="detail-table">
            <ng-container
              [matColumnDef]="column"
              *ngFor="
                let column of getColumnDefs(tableIndex);
                let columnIndex = index
              "
            >
              <th class="detailTableTh" mat-header-cell *matHeaderCellDef>
                <input
                  matInput
                  class="table_column_name_input"
                  [value]="table.columns[columnIndex].colName"
                />
              </th>
              <td
                class="detailTableTd"
                mat-cell
                *matCellDef="let element; let rowIndex = index"
              >
                <input
                  matInput
                  class="table_row_name_input"
                  [value]="getRowValue(tableIndex, rowIndex, columnIndex)"
                />
              </td>
            </ng-container>

            <tr
              mat-header-row
              *matHeaderRowDef="getColumnDefs(tableIndex)"
            ></tr>
            <tr
              mat-row
              *matRowDef="let row; columns: getColumnDefs(tableIndex)"
            ></tr>
          </table>
        </div>
      </div>
    </section>
    <form #projectSetupForm="ngForm" (keydown.enter)="$event.preventDefault()">
      <div style="margin-top: 2.625rem">
        <span class="itProjectHeader" style="font-size: 1.313rem"
          >Page One</span
        >
      </div>
      <div style="margin-top: 1.5rem; display: flex">
        <div style="width: 34rem; height: 6.25rem">
          <div style="display: inline-block; margin-top: 1.125rem">
            <mat-form-field class="itFields" style="width: 30rem">
              <input
                matInput
                readonly="true"
                placeholder="PaTI ID #"
                [(ngModel)]="displayPatiProject"
                name="displayPatiProject"
              />
            </mat-form-field>
          </div>
        </div>
      </div>
      <div style="display: flex">
        <div style="margin-top: 1.5rem">
          <div *ngIf="!editFormMode" style="width: 23.438rem; height: 6.25rem">
            <div style="display: inline-block; margin-top: 1.125rem">
              <mat-form-field
                class="itFields"
                style="width: 19.4rem"
                [floatLabel]="'always'"
              >
                <input
                  maxlength="35"
                  readonly="true"
                  [(ngModel)]="projectName"
                  placeholder="Short Description (Max 35 Characters)"
                  matInput
                  name="projectName"
                />
              </mat-form-field>
            </div>
          </div>
          <div
            *ngIf="editFormMode"
            style="width: 23.438rem; height: 6.25rem; background-color: #f3fafd"
          >
            <div
              style="
                display: inline-block;
                margin-top: 1.125rem;
                margin-left: 1.5rem;
              "
            >
              <mat-form-field
                class="itFields"
                style="
                  width: 19.4rem;
                  padding-left: 0.5rem;
                  padding-right: 0.5rem;
                "
              >
                <input
                  maxlength="35"
                  [(ngModel)]="projectNameCopy"
                  placeholder="Short Description (Max 35 Characters)"
                  matInput
                  required
                  name="shortDescField"
                />
              </mat-form-field>
            </div>
          </div>
        </div>
        <div style="display: inline-block; margin-top: 1.5rem">
          <div *ngIf="!editFormMode" style="width: 23.438rem; height: 6.25rem">
            <div
              style="
                display: inline-block;
                margin-top: 1.125rem;
                margin-left: 1.5rem;
              "
            >
              <mat-form-field class="itFields" style="width: 19.4rem">
                <input
                  placeholder="IT Project Classification"
                  readonly="true"
                  matInput
                  [(ngModel)]="itProjectClassification.ets_proj_classification"
                  name="ets_proj_classification"
                />
              </mat-form-field>
            </div>
          </div>
          <div
            *ngIf="editFormMode"
            style="width: 23.438rem; height: 6.25rem; background-color: #f3fafd"
          >
            <div
              style="
                display: inline-block;
                margin-top: 1.125rem;
                margin-left: 1.5rem;
              "
            >
              <mat-form-field
                class="itFields"
                style="
                  width: 19.4rem;
                  padding-left: 0.5rem;
                  padding-right: 0.5rem;
                "
              >
                <mat-select
                  [(ngModel)]="itProjectClassificationCopy"
                  placeholder="IT Project Classification"
                  required
                  name="classificationField"
                  [compareWith]="compareItProjectClassification"
                >
                  <mat-option
                    *ngFor="let option of itProjectClassificationOptions"
                    style="color: #696969"
                    [value]="option"
                    ><span>{{
                      option.ets_proj_classification
                    }}</span></mat-option
                  >
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
      <div style="margin-top: 1.5rem; margin-right: 1.5rem">
        <div *ngIf="!editFormMode" style="width: 48.375rem; height: 6.25rem">
          <mat-form-field
            style="
              background: white;
              padding-right: 1.5rem;
              margin-top: 1.125rem;
              width: 21.438rem;
              height: 4rem;
            "
          >
            <mat-label>Estimated Start Date</mat-label>
            <input
              matInput
              readonly="true"
              #datepickerInput1
              [matDatepicker]="startDatePicker"
              [(ngModel)]="estimatedStartDate"
              style="color: #696969"
              name="estimatedStartDate"
            />
            <mat-datepicker #startDatePicker></mat-datepicker>
          </mat-form-field>
          <mat-form-field
            style="
              background: white;
              padding-left: 0.4rem;
              padding-right: 0.4rem;
              margin-left: 1.5rem;
              width: 21.438rem;
              height: 4rem;
            "
          >
            <mat-label>Estimated In Service Date</mat-label>
            <input
              matInput
              readonly="true"
              #datepickerInput2
              [matDatepicker]="inServiceDatePicker"
              [(ngModel)]="estimatedInServiceDate"
              style="color: #696969"
              name="estimatedInServiceDate"
            />
            <mat-datepicker #inServiceDatePicker></mat-datepicker>
          </mat-form-field>
        </div>
        <div
          *ngIf="editFormMode"
          style="width: 48.375rem; height: 6.25rem; background-color: #f3fafd"
        >
          <mat-form-field
            style="
              background: white;
              padding-left: 0.4rem;
              padding-right: 0.4rem;
              margin-top: 1.125rem;
              margin-left: 1.5rem;
              width: 21.438rem;
              height: 4rem;
            "
          >
            <mat-label>Estimated Start Date</mat-label>
            <input
              matInput
              #datepickerInput1
              [matDatepicker]="startDatePicker"
              [(ngModel)]="estimatedStartDateCopy"
              style="color: #696969"
              [max]="estimatedInServiceDateCopy"
              (dateChange)="onStartDateChange()"
              required
              name="estimatedStartDateField"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="startDatePicker"
            ></mat-datepicker-toggle>
            <mat-datepicker #startDatePicker></mat-datepicker>
          </mat-form-field>
          <mat-form-field
            style="
              background: white;
              padding-left: 0.4rem;
              padding-right: 0.4rem;
              margin-left: 1.5rem;
              width: 21.438rem;
              height: 4rem;
            "
          >
            <mat-label>Estimated In Service Date</mat-label>
            <input
              matInput
              #datepickerInput2
              [matDatepicker]="inServiceDatePicker"
              [(ngModel)]="estimatedInServiceDateCopy"
              [min]="minimumInServiceDate()"
              style="color: #696969"
              (dateChange)="onInServiceDateChange()"
              required
              name="estimatedInServiceDateField"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="inServiceDatePicker"
            ></mat-datepicker-toggle>
            <mat-datepicker #inServiceDatePicker></mat-datepicker>
          </mat-form-field>
        </div>
      </div>
      <div style="margin-top: 1.5rem">
        <span
          class="projectScopeHeader"
          [style.color]="
            projectSetupForm.controls['projectScopeDescriptionField']
              ?.touched &&
            projectSetupForm.controls['projectScopeDescriptionField']?.errors
              ?.required
              ? '#9e1b32'
              : ''
          "
          >Overview and Scope</span
        >
      </div>
      <div style="margin-top: 0.688rem">
        <div *ngIf="!editFormMode" class="p-1 grey-border text-grey width-60">
          {{ projectScopeDescription }}
        </div>
        <textarea
          *ngIf="editFormMode"
          [style.border]="
            projectSetupForm.controls['projectScopeDescriptionField']
              ?.touched &&
            projectSetupForm.controls['projectScopeDescriptionField']?.errors
              ?.required
              ? '1px solid #9e1b32'
              : '1px solid #26bcd7'
          "
          [(ngModel)]="projectScopeDescriptionCopy"
          class="scopeDescriptionTextBox"
          maxlength="255"
          required
          name="projectScopeDescriptionField"
        ></textarea>
      </div>
      <div style="margin-top: 1.5rem">
        <span class="projectScopeHeader">Contacts</span>
      </div>
      <div style="margin-top: 0.688rem">
        <div *ngIf="!editFormMode" style="width: 66.375rem; height: 6.25rem">
          <mat-form-field
            class="itFields"
            style="margin-top: 1.125rem; width: 55.638rem; height: 4rem"
          >
            <input
              readonly="true"
              name="primaryContact"
              type="text"
              placeholder="Primary Contact"
              matInput
              [(ngModel)]="displayPrimaryContact"
            />
          </mat-form-field>
        </div>
        <div
          *ngIf="editFormMode"
          style="width: 66.375rem; height: 6.25rem; background-color: #f3fafd"
        >
          <mat-form-field
            *ngIf="!(primaryContactCopy && primaryContactCopy.mail)"
            class="itFields"
            style="
              margin-top: 1.125rem;
              margin-left: 1.5rem;
              width: 55.638rem;
              height: 4rem;
              padding-left: 0.5rem;
              padding-right: 0.5rem;
            "
          >
            <input
              name="primaryContactField"
              type="text"
              placeholder="Primary Contact (Search for a name and then make a selection)"
              matAutocompletePosition="below"
              matInput
              [matAutocomplete]="auto1"
              [formControl]="primaryContactControl"
              [(ngModel)]="primaryContactCopy"
              required
              (keydown.enter)="searchUsersPrimaryContact($event.target.value)"
            />
          </mat-form-field>
          <mat-form-field
            *ngIf="primaryContactCopy && primaryContactCopy.mail"
            class="itFields"
            style="
              margin-top: 1.125rem;
              margin-left: 1.5rem;
              width: 55.638rem;
              height: 4rem;
              padding-left: 0.5rem;
              padding-right: 0.5rem;
            "
          >
            <input
              name="primaryContactField"
              type="text"
              placeholder="Primary Contact (Search for a name and then make a selection)"
              matAutocompletePosition="below"
              matInput
              [matAutocomplete]="auto1"
              [formControl]="primaryContactControl"
              [(ngModel)]="primaryContactCopy"
              readonly="true"
            />
          </mat-form-field>
          <mat-autocomplete
            #auto1="matAutocomplete"
            [displayWith]="displayFnPrimaryContact"
          >
            <mat-option
              *ngFor="let option of primaryContactOptions"
              style="color: #696969"
              [value]="option"
            >
              <span
                *ngIf="option.givenName && option.surname && option.jobTitle"
                >{{ option.givenName }} {{ option.surname }} ({{
                  option.mail
                }}), {{ option.jobTitle }}</span
              >
              <span
                *ngIf="option.givenName && option.surname && !option.jobTitle"
                >{{ option.givenName }} {{ option.surname }} ({{
                  option.mail
                }})</span
              >
              <span
                *ngIf="!(option.givenName && option.surname) && option.jobTitle"
                >{{ option.displayName }} ({{ option.mail }}),
                {{ option.jobTitle }}</span
              >
              <span
                *ngIf="
                  !(option.givenName && option.surname) && !option.jobTitle
                "
                >{{ option.displayName }} ({{ option.mail }})</span
              >
            </mat-option>
          </mat-autocomplete>
          <div
            *ngIf="primaryContactCopy && primaryContactCopy.mail"
            style="
              display: inline-block;
              padding-top: 1.813rem;
              z-index: 0;
              position: absolute;
            "
          >
            <img
              (click)="deletePrimaryContact()"
              style="margin-left: -1.5rem; cursor: pointer"
              src="assets/close-window.svg"
            />
          </div>
          <div style="display: inline-block; margin-left: 0.938rem">
            <button
              class="confirmButton"
              type="button"
              style="width: 5rem"
              (click)="searchUsersPrimaryContact(primaryContactCopy)"
            >
              <span class="confirmText">SEARCH</span>
            </button>
          </div>
        </div>
      </div>
      <div style="margin-top: 0.688rem">
        <div *ngIf="!editFormMode" style="width: 66.375rem; height: 6.25rem">
          <mat-form-field
            class="itFields"
            style="margin-top: 1.125rem; width: 55.638rem; height: 4rem"
          >
            <input
              readonly="true"
              name="itSponsor"
              type="text"
              placeholder="Sponsor"
              matInput
              [(ngModel)]="displayItSponsor"
              name="displayItSponsor"
            />
          </mat-form-field>
        </div>
        <div
          *ngIf="editFormMode"
          style="width: 66.375rem; height: 6.25rem; background-color: #f3fafd"
        >
          <mat-form-field
            *ngIf="!(itSponsorCopy && itSponsorCopy.mail)"
            class="itFields"
            style="
              margin-top: 1.125rem;
              margin-left: 1.5rem;
              width: 55.638rem;
              height: 4rem;
              padding-left: 0.5rem;
              padding-right: 0.5rem;
            "
          >
            <input
              name="itSponsorField"
              type="text"
              placeholder="Sponsor (Search for a name and then make a selection)"
              matAutocompletePosition="below"
              matInput
              [matAutocomplete]="auto2"
              [formControl]="itSponsorControl"
              [(ngModel)]="itSponsorCopy"
              (keydown.enter)="searchUsersItSponsor($event.target.value)"
              required
            />
          </mat-form-field>
          <mat-form-field
            *ngIf="itSponsorCopy && itSponsorCopy.mail"
            class="itFields"
            style="
              margin-top: 1.125rem;
              margin-left: 1.5rem;
              width: 55.638rem;
              height: 4rem;
              padding-left: 0.5rem;
              padding-right: 0.5rem;
            "
          >
            <input
              name="itSponsor"
              type="text"
              placeholder="Sponsor (Search for a name and then make a selection)"
              matAutocompletePosition="below"
              matInput
              [matAutocomplete]="auto2"
              [formControl]="itSponsorControl"
              [(ngModel)]="itSponsorCopy"
              readonly="true"
            />
          </mat-form-field>
          <mat-autocomplete
            #auto2="matAutocomplete"
            [displayWith]="displayFnITSponsor"
            (optionSelected)="getDOA($event.option.value.mailNickname, 0, true)"
          >
            <mat-option
              *ngFor="let option of itSponsorOptions"
              style="color: #696969"
              [value]="option"
            >
              <span
                *ngIf="option.givenName && option.surname && option.jobTitle"
                >{{ option.givenName }} {{ option.surname }} ({{
                  option.mail
                }}), {{ option.jobTitle }}</span
              >
              <span
                *ngIf="option.givenName && option.surname && !option.jobTitle"
                >{{ option.givenName }} {{ option.surname }} ({{
                  option.mail
                }})</span
              >
              <span
                *ngIf="!(option.givenName && option.surname) && option.jobTitle"
                >{{ option.displayName }} ({{ option.mail }}),
                {{ option.jobTitle }}</span
              >
              <span
                *ngIf="
                  !(option.givenName && option.surname) && !option.jobTitle
                "
                >{{ option.displayName }} ({{ option.mail }})</span
              >
            </mat-option>
          </mat-autocomplete>
          <div
            *ngIf="itSponsorCopy && itSponsorCopy.mail"
            style="
              display: inline-block;
              padding-top: 1.813rem;
              z-index: 0;
              position: absolute;
            "
          >
            <img
              (click)="deleteITSponsor()"
              style="margin-left: -1.5rem; cursor: pointer"
              src="assets/close-window.svg"
            />
          </div>
          <div style="display: inline-block; margin-left: 0.938rem">
            <button
              class="confirmButton"
              type="button"
              style="width: 5rem"
              (click)="searchUsersItSponsor(itSponsorCopy)"
            >
              <span class="confirmText">SEARCH</span>
            </button>
          </div>
        </div>
      </div>
      <div *ngIf="!editFormMode">
        <div style="display: flex; gap: 1rem; color: dimgray">
          <span>Is this request O&M only?</span>
          <mat-radio-group [(ngModel)]="omOnly" name="omOnlyField" disabled>
            <mat-radio-button color="primary" [value]="'YES'">
              <span class="choiceText">YES</span>
            </mat-radio-button>
            <mat-radio-button
              color="primary"
              [value]="'NO'"
              style="margin-left: 1.125rem"
            >
              <span class="choiceText">NO</span>
            </mat-radio-button>
          </mat-radio-group>
        </div>
      </div>
      <div
        style="
          width: fit-content;
          background-color: #f3fafd;
          margin-top: 1.5rem;
          padding: 1rem 1.5rem;
        "
        *ngIf="editFormMode"
      >
        <div
          style="
            display: flex;
            gap: 1rem;
            color: dimgray;
            padding: 0.5rem;
            background-color: white;
          "
        >
          <span
            [style.color]="
              projectSetupForm.submitted &&
              projectSetupForm.controls['omOnlyField']?.errors?.required
                ? '#9e1b32'
                : ''
            "
            >Is this request O&M only?</span
          >
          <mat-radio-group
            [(ngModel)]="omOnlyCopy"
            required
            name="omOnlyField"
            (change)="omOnlyChanged()"
          >
            <mat-radio-button color="primary" [value]="'YES'">
              <span class="choiceText">YES</span>
            </mat-radio-button>
            <mat-radio-button
              color="primary"
              [value]="'NO'"
              style="margin-left: 1.125rem"
            >
              <span class="choiceText">NO</span>
            </mat-radio-button>
          </mat-radio-group>
        </div>
      </div>
      <div style="margin-top: 1.5rem">
        <div style="width: 24.438rem; height: 6.25rem">
          <div style="display: inline-block; margin-top: 1.125rem">
            <mat-form-field
              class="itFields"
              style="width: 20.4rem"
              *ngIf="!editFormMode"
            >
              <input
                readonly="true"
                type="text"
                placeholder="Does this work relate to:"
                matInput
                [(ngModel)]="relatedWork"
                name="relatedWorkField"
              />
            </mat-form-field>
            <mat-form-field
              class="itFields"
              style="width: 20.4rem"
              *ngIf="editFormMode"
            >
              <mat-select
                [(ngModel)]="relatedWorkCopy"
                placeholder="Does this work relate to:"
                (selectionChange)="relatedWorkChanged()"
                required
                name="relatedWorkField"
              >
                <mat-option
                  *ngFor="let option of hardwareOrSoftwareOptions"
                  style="color: #696969"
                  [value]="option"
                  ><span>{{ option }}</span></mat-option
                >
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>
      <div
        *ngIf="
          hardwareOrSoftwareCopy === 'Hardware Only' ||
          hardwareOrSoftwareCopy === 'Hardware and Software'
        "
      >
        <div style="margin-top: 1.5rem">
          <span class="projectScopeHeader">Hardware Details</span>
        </div>
        <div style="margin-top: 0.688rem">
          <div *ngIf="!editFormMode" style="width: 73.25rem">
            <div style="position: relative">
              <div
                style="
                  display: inline-block;
                  margin-top: 1.5rem;
                  margin-bottom: 1.5rem;
                  width: 34.438rem;
                "
              >
                <span class="bodyText"
                  >Are you purchasing any service warranties? (If yes, the cost
                  of service warranties should be included in O&M estimate; none
                  of this cost can be capitalized)</span
                >
              </div>
              <div
                style="
                  display: inline-block;
                  margin-top: 1.5rem;
                  margin-left: 7.375rem;
                  vertical-align: top;
                  position: absolute;
                  top: 0.625rem;
                "
              >
                <mat-radio-group
                  [(ngModel)]="purchasingWarrantiesCopy"
                  disabled
                  name="purchasingWarrantiesCopy"
                >
                  <mat-radio-button color="primary" [value]="'YES'"
                    >YES</mat-radio-button
                  >
                  <mat-radio-button
                    color="primary"
                    [value]="'NO'"
                    style="margin-left: 1.125rem"
                    >NO</mat-radio-button
                  >
                </mat-radio-group>
              </div>
            </div>
          </div>
          <div
            *ngIf="editFormMode"
            style="width: 73.25rem; background-color: #f3fafd"
          >
            <div style="position: relative">
              <div
                style="
                  display: inline-block;
                  margin-top: 1.5rem;
                  margin-left: 1.5rem;
                  margin-bottom: 1.5rem;
                  width: 34.438rem;
                "
              >
                <span
                  class="bodyText"
                  [style.color]="
                    projectSetupForm.controls['purchasingWarrantiesField']
                      ?.touched &&
                    projectSetupForm.controls['purchasingWarrantiesField']
                      ?.errors?.required
                      ? '#9e1b32'
                      : ''
                  "
                  >Are you purchasing any service warranties? (If yes, the cost
                  of service warranties should be included in O&M estimate; none
                  of this cost can be capitalized)</span
                >
              </div>
              <div
                style="
                  display: inline-block;
                  margin-top: 1.5rem;
                  margin-left: 7.375rem;
                  vertical-align: top;
                  position: absolute;
                  top: 0.625rem;
                "
              >
                <mat-radio-group
                  [(ngModel)]="purchasingWarrantiesCopy"
                  required
                  name="purchasingWarrantiesField"
                >
                  <mat-radio-button color="primary" [value]="'YES'">
                    <span class="choiceText">YES</span>
                  </mat-radio-button>
                  <mat-radio-button
                    color="primary"
                    [value]="'NO'"
                    style="margin-left: 1.125rem"
                  >
                    <span class="choiceText">NO</span>
                  </mat-radio-button>
                </mat-radio-group>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        *ngIf="
          hardwareOrSoftwareCopy === 'Software Only' ||
          hardwareOrSoftwareCopy === 'Hardware and Software'
        "
      >
        <div style="margin-top: 1.5rem">
          <span class="projectScopeHeader">Software Details</span>
        </div>
        <div style="margin-top: 0.688rem">
          <div *ngIf="!editFormMode" style="width: 73.25rem">
            <div style="padding-top: 1rem">
              <span style="color: gray"
                >Work consists of the following: (Select all that apply)</span
              >
              <div
                *ngFor="let option of projectConsistsOfOptions; let i = index"
                style="text-align: left; margin-bottom: 0.938rem"
              >
                <mat-checkbox
                  color="primary"
                  disabled
                  [checked]="projectConsistsOfCheckboxes[i]"
                >
                  <span style="color: #696969; white-space: normal">{{
                    option
                  }}</span>
                </mat-checkbox>
              </div>
            </div>
            <div>
              <div style="display: inline-block; margin-top: 1.5rem">
                <mat-form-field
                  class="itFields"
                  style="width: 20.4rem"
                  [floatLabel]="'always'"
                >
                  <input
                    type="number"
                    step="1"
                    min="0"
                    [(ngModel)]="expectedLife"
                    placeholder="What is the expected life of the software (years)?"
                    oninput="this.value = !!this.value && Math.abs(this.value) >= 0 ? Math.abs(this.value) : null"
                    matInput
                    required
                    name="expectedLifeField"
                  />
                </mat-form-field>
              </div>
            </div>
            <div style="position: relative">
              <div
                style="
                  display: inline-block;
                  margin-top: 1.5rem;
                  width: 34.438rem;
                "
              >
                <span class="bodyText">Is this an Agile effort?</span>
              </div>
              <div
                style="
                  display: inline-block;
                  margin-top: 1.5rem;
                  margin-left: 7.375rem;
                  vertical-align: top;
                  position: absolute;
                  top: 0.625rem;
                "
              >
                <mat-radio-group
                  [(ngModel)]="agileEffort"
                  disabled
                  name="agileEffor"
                >
                  <mat-radio-button color="primary" [value]="'YES'">
                    <span class="choiceText">YES</span>
                  </mat-radio-button>
                  <mat-radio-button
                    color="primary"
                    [value]="'NO'"
                    style="margin-left: 1.125rem"
                  >
                    <span class="choiceText">NO</span>
                  </mat-radio-button>
                </mat-radio-group>
              </div>
            </div>
            <div style="position: relative">
              <div
                style="
                  display: inline-block;
                  margin-top: 1.5rem;
                  width: 34.438rem;
                "
              >
                <span class="bodyText"
                  >Does the software currently exist or is it being used for any
                  other jurisdictions, department, business unit, or
                  function?</span
                >
              </div>
              <div
                style="
                  display: inline-block;
                  margin-top: 1.5rem;
                  margin-left: 7.375rem;
                  vertical-align: top;
                  position: absolute;
                  top: 0.625rem;
                "
              >
                <mat-radio-group
                  [(ngModel)]="softwareBeingUsed"
                  disabled
                  name="softwareBeingUsed"
                >
                  <mat-radio-button color="primary" [value]="'YES'">
                    <span class="choiceText">YES</span>
                  </mat-radio-button>
                  <mat-radio-button
                    color="primary"
                    [value]="'NO'"
                    style="margin-left: 1.125rem"
                  >
                    <span class="choiceText">NO</span>
                  </mat-radio-button>
                </mat-radio-group>
              </div>
            </div>
            <div>
              <div style="display: inline-block; margin-top: 1.5rem">
                <mat-form-field class="itFields" style="width: 19.4rem">
                  <input
                    readonly="true"
                    [(ngModel)]="vendorName"
                    placeholder="Vendor Name (Optional)"
                    matInput
                    name="vendorName"
                  />
                </mat-form-field>
              </div>
              <div
                style="
                  display: inline-block;
                  margin-top: 1.5rem;
                  margin-left: 1.5rem;
                "
              >
                <mat-form-field class="itFields" style="width: 19.4rem">
                  <input
                    readonly="true"
                    [(ngModel)]="softwareName"
                    placeholder="Software Name"
                    matInput
                    name="softwareName"
                  />
                </mat-form-field>
              </div>
              <div
                [class.hideText]="softwareBeingUsed === 'NO'"
                style="
                  display: inline-block;
                  margin-top: 1.5rem;
                  margin-left: 1.5rem;
                "
              >
                <mat-form-field class="itFields" style="width: 19.4rem">
                  <input
                    readonly="true"
                    [(ngModel)]="inServiceYear"
                    placeholder="In what year did it go in service?"
                    matInput
                    name="inServiceYear"
                  />
                </mat-form-field>
              </div>
            </div>
            <div style="margin-top: 1.5rem">
              <span class="bodyText"
                >Describe the software development work needed for this
                effort:</span
              >
            </div>
            <div style="margin-top: 0.688rem">
              <textarea
                [(ngModel)]="softwareProjectOverview"
                name="softwareProjectOverview"
                class="softwareProjectOverviewTextBox"
                style="height: 4rem; width: 45.375rem"
              ></textarea>
            </div>
            <div style="width: 49.438rem">
              <div
                style="
                  display: inline-block;
                  margin-top: 1.5rem;
                  width: 37.688rem;
                "
              >
                <span class="bodyText"
                  >Will you have data conversion activities? (If yes, the cost
                  of running processes or manually cleaning up data should be
                  included in O&M estimate; only development of data conversion
                  software can be capitalized)</span
                >
              </div>
              <div
                style="
                  display: inline-block;
                  margin-top: 1.5rem;
                  vertical-align: top;
                  float: right;
                "
              >
                <mat-radio-group
                  [(ngModel)]="dataConversionActivities"
                  disabled
                  name="dataConversionActivities"
                >
                  <mat-radio-button color="primary" [value]="'YES'">
                    <span class="choiceText">YES</span>
                  </mat-radio-button>
                  <mat-radio-button
                    color="primary"
                    [value]="'NO'"
                    style="margin-left: 1.125rem"
                  >
                    <span class="choiceText">NO</span>
                  </mat-radio-button>
                </mat-radio-group>
              </div>
            </div>
            <div style="width: 49.438rem">
              <div
                style="
                  display: inline-block;
                  margin-top: 1.5rem;
                  width: 37.688rem;
                "
              >
                <span class="bodyText"
                  >Will you have training costs? (If yes, the cost of
                  train-the-trainer and user training should be included in O&M
                  estimate; only developer training on how to develop the
                  software can be capitalized)</span
                >
              </div>
              <div
                style="
                  display: inline-block;
                  margin-top: 1.5rem;
                  vertical-align: top;
                  float: right;
                "
              >
                <mat-radio-group
                  [(ngModel)]="trainingCosts"
                  disabled
                  name="trainingCosts"
                >
                  <mat-radio-button color="primary" [value]="'YES'">
                    <span class="choiceText">YES</span>
                  </mat-radio-button>
                  <mat-radio-button
                    color="primary"
                    [value]="'NO'"
                    style="margin-left: 1.125rem"
                  >
                    <span class="choiceText">NO</span>
                  </mat-radio-button>
                </mat-radio-group>
              </div>
            </div>
            <div style="width: 49.438rem">
              <div
                style="
                  display: inline-block;
                  margin-top: 1.5rem;
                  width: 37.688rem;
                "
              >
                <span class="bodyText"
                  >Is there an associated retirement of existing software?</span
                >
              </div>
              <div
                style="
                  display: inline-block;
                  margin-top: 1.5rem;
                  vertical-align: top;
                  float: right;
                "
              >
                <mat-radio-group
                  [(ngModel)]="associatedRetirement"
                  disabled
                  name="associatedRetirement"
                >
                  <mat-radio-button color="primary" [value]="'YES'">
                    <span class="choiceText">YES</span>
                  </mat-radio-button>
                  <mat-radio-button
                    color="primary"
                    [value]="'NO'"
                    style="margin-left: 1.125rem"
                  >
                    <span class="choiceText">NO</span>
                  </mat-radio-button>
                </mat-radio-group>
              </div>
            </div>
            <div
              [class.hideElements]="associatedRetirement !== 'YES'"
              style="display: inline-block"
            >
              <div style="display: inline-block; margin-top: 0.688rem">
                <mat-form-field class="itFields" style="width: 19.4rem">
                  <input
                    readonly="true"
                    [(ngModel)]="softwareToBeRetired"
                    placeholder="Software To Be Retired"
                    matInput
                    name="softwareToBeRetired"
                  />
                </mat-form-field>
              </div>
              <div
                style="
                  display: inline-block;
                  margin-top: 0.688rem;
                  margin-left: 1.5rem;
                "
              >
                <mat-form-field class="itFields" style="width: 19.4rem">
                  <input
                    readonly="true"
                    [(ngModel)]="retiredInServiceDate"
                    placeholder="When was it in service?"
                    matInput
                    name="retiredInServiceDate"
                  />
                </mat-form-field>
              </div>
            </div>
            <div style="width: 49.438rem">
              <div
                style="
                  display: inline-block;
                  margin-top: 1.5rem;
                  width: 37.688rem;
                "
              >
                <span class="bodyText"
                  >Will you have any maintenance contracts/agreements?</span
                >
              </div>
              <div
                [class.moveDown]="associatedRetirement === 'YES'"
                style="
                  display: inline-block;
                  margin-top: 1.5rem;
                  vertical-align: top;
                  float: right;
                  position: relative;
                  top: -3.313rem;
                "
              >
                <mat-radio-group
                  [(ngModel)]="maintenanceContracts"
                  disabled
                  name="maintenanceContracts"
                >
                  <mat-radio-button color="primary" [value]="'YES'">
                    <span class="choiceText">YES</span>
                  </mat-radio-button>
                  <mat-radio-button
                    color="primary"
                    [value]="'NO'"
                    style="margin-left: 1.125rem"
                  >
                    <span class="choiceText">NO</span>
                  </mat-radio-button>
                </mat-radio-group>
              </div>
            </div>
            <div style="width: 49.438rem">
              <div
                style="
                  display: inline-block;
                  margin-top: 1.5rem;
                  width: 37.688rem;
                "
              >
                <span class="bodyText"
                  >Are you replacing any existing interfaces?</span
                >
              </div>
              <div
                [class.moveLeft]="associatedRetirement === 'YES'"
                style="
                  display: inline-block;
                  margin-top: 1.5rem;
                  vertical-align: top;
                  float: right;
                  position: relative;
                  top: -3.313rem;
                  left: 7.48rem;
                "
              >
                <mat-radio-group
                  [(ngModel)]="replacingInterfaces"
                  disabled
                  name="replacingInterfaces"
                >
                  <mat-radio-button color="primary" [value]="'YES'">
                    <span class="choiceText">YES</span>
                  </mat-radio-button>
                  <mat-radio-button
                    color="primary"
                    [value]="'NO'"
                    style="margin-left: 1.125rem"
                  >
                    <span class="choiceText">NO</span>
                  </mat-radio-button>
                </mat-radio-group>
              </div>
            </div>
            <div>
              <mat-form-field
                class="itFields"
                style="
                  margin-top: 1.5rem;
                  margin-bottom: 1.5rem;
                  width: 30.938rem;
                "
              >
                <input
                  required
                  type="text"
                  placeholder="How will the software be released?"
                  matInput
                  [(ngModel)]="howSoftwareReleased"
                  name="howSoftwareReleasedField"
                />
              </mat-form-field>
            </div>
            <div *ngIf="isVendorHosted()" style="width: 49.438rem">
              <div style="display: inline-block; width: 37.688rem">
                <span class="bodyText">Will Duke own perpetual licenses?</span>
              </div>
              <div
                style="
                  display: inline-block;
                  vertical-align: top;
                  float: right;
                  position: relative;
                "
              >
                <mat-radio-group
                  [(ngModel)]="perpetualLicenses"
                  disabled
                  name="perpetualLicenses"
                >
                  <mat-radio-button color="primary" [value]="'YES'">
                    <span class="choiceText">YES</span>
                  </mat-radio-button>
                  <mat-radio-button
                    color="primary"
                    [value]="'NO'"
                    style="margin-left: 1.125rem"
                  >
                    <span class="choiceText">NO</span>
                  </mat-radio-button>
                </mat-radio-group>
              </div>
            </div>
            <div *ngIf="isVendorHosted()" style="width: 49.438rem">
              <div
                style="
                  display: inline-block;
                  margin-top: 1.5rem;
                  width: 36.688rem;
                "
              >
                <span class="bodyText"
                  >Does Duke have the contractual right to take possession of
                  the software at any time during the arrangement period?</span
                >
              </div>
              <div
                style="
                  display: inline-block;
                  margin-top: 1.5rem;
                  vertical-align: top;
                  float: right;
                  position: relative;
                  top: -3.313rem;
                "
              >
                <mat-radio-group
                  [(ngModel)]="contractualRight"
                  disabled
                  name="contractualRight"
                >
                  <mat-radio-button color="primary" [value]="'YES'">
                    <span class="choiceText">YES</span>
                  </mat-radio-button>
                  <mat-radio-button
                    color="primary"
                    [value]="'NO'"
                    style="margin-left: 1.125rem"
                  >
                    <span class="choiceText">NO</span>
                  </mat-radio-button>
                </mat-radio-group>
              </div>
            </div>
            <div *ngIf="isVendorHosted()" style="width: 49.438rem">
              <div
                style="
                  display: inline-block;
                  margin-top: 1.5rem;
                  width: 37.688rem;
                "
              >
                <span class="bodyText"
                  >Is there a significant penalty to take possession of the
                  software and bring it in house? (Significant penalty is
                  interpreted as either a significant cost or significant
                  reduction in value or functionality when taking possession of
                  the software. Significant cost is defined as greater than 15%
                  of the total capital cost of the project)</span
                >
              </div>
              <div
                style="
                  display: inline-block;
                  margin-top: 1.5rem;
                  vertical-align: top;
                  float: right;
                  position: relative;
                  top: -6.313rem;
                "
              >
                <mat-radio-group
                  [(ngModel)]="significantPenalty"
                  disabled
                  name="significantPenalty"
                >
                  <mat-radio-button color="primary" [value]="'YES'">
                    <span class="choiceText">YES</span>
                  </mat-radio-button>
                  <mat-radio-button
                    color="primary"
                    [value]="'NO'"
                    style="margin-left: 1.125rem"
                  >
                    <span class="choiceText">NO</span>
                  </mat-radio-button>
                </mat-radio-group>
              </div>
            </div>
            <div *ngIf="isVendorHosted()" style="width: 49.438rem">
              <div
                style="
                  display: inline-block;
                  margin-top: 1.5rem;
                  width: 34.688rem;
                "
              >
                <span class="bodyText"
                  >Is it feasible for Duke to run the software on our own
                  hardware or to contract with another third party host?</span
                >
              </div>
              <div
                style="
                  display: inline-block;
                  margin-top: 0.5rem;
                  vertical-align: top;
                  float: right;
                  position: relative;
                  top: -3.313rem;
                "
              >
                <mat-radio-group
                  [(ngModel)]="isFeasible"
                  disabled
                  name="isFeasible"
                >
                  <mat-radio-button color="primary" [value]="'YES'">
                    <span class="choiceText">YES</span>
                  </mat-radio-button>
                  <mat-radio-button
                    color="primary"
                    [value]="'NO'"
                    style="margin-left: 1.125rem"
                  >
                    <span class="choiceText">NO</span>
                  </mat-radio-button>
                </mat-radio-group>
              </div>
            </div>
            <div *ngIf="isVendorHosted()" style="width: 49.438rem">
              <div
                style="
                  display: inline-block;
                  margin-top: 1.5rem;
                  width: 37.688rem;
                "
              >
                <span class="bodyText">Are there service or usage fees?</span>
              </div>
              <div
                style="
                  display: inline-block;
                  margin-top: 1.5rem;
                  vertical-align: top;
                  float: right;
                  position: relative;
                  top: -3.313rem;
                "
              >
                <mat-radio-group
                  [(ngModel)]="serviceFees"
                  disabled
                  name="serviceFees"
                >
                  <mat-radio-button color="primary" [value]="'YES'">
                    <span class="choiceText">YES</span>
                  </mat-radio-button>
                  <mat-radio-button
                    color="primary"
                    [value]="'NO'"
                    style="margin-left: 1.125rem"
                  >
                    <span class="choiceText">NO</span>
                  </mat-radio-button>
                </mat-radio-group>
              </div>
            </div>
            <div *ngIf="isVendorHosted()" style="width: 49.438rem">
              <div
                style="
                  display: inline-block;
                  margin-top: 1.5rem;
                  margin-bottom: 1.5rem;
                  width: 37.688rem;
                "
              >
                <span class="bodyText"
                  >If we stop paying the service or usage fees, can we still use
                  the software?</span
                >
              </div>
              <div
                style="
                  display: inline-block;
                  vertical-align: top;
                  float: right;
                  position: relative;
                  top: -3.313rem;
                "
              >
                <mat-radio-group
                  [(ngModel)]="useWithoutPaying"
                  disabled
                  name="useWithoutPaying"
                >
                  <mat-radio-button color="primary" [value]="'YES'">
                    <span class="choiceText">YES</span>
                  </mat-radio-button>
                  <mat-radio-button
                    color="primary"
                    [value]="'NO'"
                    style="margin-left: 1.125rem"
                  >
                    <span class="choiceText">NO</span>
                  </mat-radio-button>
                </mat-radio-group>
              </div>
            </div>
          </div>
          <div
            *ngIf="editFormMode"
            style="width: 73.25rem; background-color: #f3fafd"
          >
            <div style="padding-top: 1rem; padding-left: 1rem">
              <span
                [style.color]="
                  !(projectConsistsOfCopy && projectConsistsOfCopy.length)
                    ? '#9e1b32'
                    : 'gray'
                "
                >Work consists of the following: (Select all that apply)
              </span>
              <div
                *ngFor="let option of projectConsistsOfOptions; let i = index"
                style="text-align: left; margin-bottom: 0.938rem"
              >
                <mat-checkbox
                  color="primary"
                  [checked]="projectConsistsOfCheckboxesCopy[i]"
                  (change)="consistsOfChange(i, option)"
                  required
                  name="projectConsistsOfField"
                >
                  <span style="color: #696969; white-space: normal">{{
                    option
                  }}</span>
                </mat-checkbox>
              </div>
            </div>
            <div>
              <div
                style="
                  display: inline-block;
                  margin-top: 1.5rem;
                  margin-left: 1.5rem;
                "
              >
                <mat-form-field
                  class="itFields"
                  style="
                    width: 19.4rem;
                    padding-left: 0.5rem;
                    padding-right: 0.5rem;
                  "
                  [floatLabel]="'always'"
                >
                  <input
                    type="number"
                    step="1"
                    min="0"
                    [(ngModel)]="expectedLifeCopy"
                    placeholder="What is the expected life of the software (years)?"
                    oninput="this.value = !!this.value && Math.abs(this.value) >= 0 ? Math.abs(this.value) : null"
                    matInput
                    required
                    name="expectedLifeField"
                  />
                </mat-form-field>
              </div>
            </div>
            <div style="position: relative">
              <div
                style="
                  display: inline-block;
                  margin-top: 1.5rem;
                  margin-left: 1.5rem;
                  width: 34.438rem;
                "
              >
                <span
                  class="bodyText"
                  [style.color]="
                    projectSetupForm.controls['agileEffortField']?.touched &&
                    projectSetupForm.controls['agileEffortField']?.errors
                      ?.required
                      ? '#9e1b32'
                      : ''
                  "
                  >Is this an Agile effort?</span
                >
              </div>
              <div
                style="
                  display: inline-block;
                  margin-top: 1.5rem;
                  margin-left: 7.375rem;
                  vertical-align: top;
                  position: absolute;
                  top: 0.625rem;
                "
              >
                <mat-radio-group
                  [(ngModel)]="agileEffortCopy"
                  required
                  name="agileEffortField"
                >
                  <mat-radio-button color="primary" [value]="'YES'">
                    <span class="choiceText">YES</span>
                  </mat-radio-button>
                  <mat-radio-button
                    color="primary"
                    [value]="'NO'"
                    style="margin-left: 1.125rem"
                  >
                    <span class="choiceText">NO</span>
                  </mat-radio-button>
                </mat-radio-group>
              </div>
            </div>
            <div style="position: relative">
              <div
                style="
                  display: inline-block;
                  margin-top: 1.5rem;
                  margin-left: 1.5rem;
                  width: 34.438rem;
                "
              >
                <span
                  class="bodyText"
                  [style.color]="
                    projectSetupForm.controls['softwareBeingUsedField']
                      ?.touched &&
                    projectSetupForm.controls['softwareBeingUsedField']?.errors
                      ?.required
                      ? '#9e1b32'
                      : ''
                  "
                  >Does the software currently exist or is it being used for any
                  other jurisdictions, department, business unit, or
                  function?</span
                >
              </div>
              <div
                style="
                  display: inline-block;
                  margin-top: 1.5rem;
                  margin-left: 7.375rem;
                  vertical-align: top;
                  position: absolute;
                  top: 0.625rem;
                "
              >
                <mat-radio-group
                  [(ngModel)]="softwareBeingUsedCopy"
                  required
                  name="softwareBeingUsedField"
                >
                  <mat-radio-button color="primary" [value]="'YES'">
                    <span class="choiceText">YES</span>
                  </mat-radio-button>
                  <mat-radio-button
                    color="primary"
                    [value]="'NO'"
                    style="margin-left: 1.125rem"
                  >
                    <span class="choiceText">NO</span>
                  </mat-radio-button>
                </mat-radio-group>
              </div>
            </div>
            <div>
              <div
                style="
                  display: inline-block;
                  margin-top: 1.5rem;
                  margin-left: 1.5rem;
                "
              >
                <mat-form-field
                  class="itFields"
                  style="
                    width: 19.4rem;
                    padding-left: 0.5rem;
                    padding-right: 0.5rem;
                  "
                >
                  <input
                    [(ngModel)]="vendorNameCopy"
                    placeholder="Vendor Name (Optional)"
                    matInput
                    name="vendorNameField"
                  />
                </mat-form-field>
              </div>
              <div
                style="
                  display: inline-block;
                  margin-top: 1.5rem;
                  margin-left: 1.5rem;
                "
              >
                <mat-form-field
                  class="itFields"
                  style="
                    width: 19.4rem;
                    padding-left: 0.5rem;
                    padding-right: 0.5rem;
                  "
                >
                  <input
                    [(ngModel)]="softwareNameCopy"
                    placeholder="Software Name (Optional)"
                    matInput
                    name="softwareNameField"
                  />
                </mat-form-field>
              </div>
              <div
                *ngIf="softwareBeingUsedCopy !== 'NO'"
                style="
                  display: inline-block;
                  margin-top: 1.5rem;
                  margin-left: 1.5rem;
                "
              >
                <mat-form-field
                  class="itFields"
                  style="
                    width: 19.4rem;
                    padding-left: 0.5rem;
                    padding-right: 0.5rem;
                  "
                >
                  <input
                    matInput
                    readonly
                    [(ngModel)]="inServiceYearCopy"
                    placeholder="In what year did it go in service?"
                    required
                    name="inServiceYearField"
                  />
                  <input
                    matInput
                    [matDatepicker]="dp"
                    [max]="currentDate"
                    [value]="getInServiceDate()"
                    class="service-year-dummy-input"
                  />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="dp"
                  ></mat-datepicker-toggle>
                  <mat-datepicker
                    #dp
                    startView="multi-year"
                    (yearSelected)="onInServiceYearSelection($event, dp)"
                  >
                  </mat-datepicker>
                </mat-form-field>
              </div>
            </div>
            <div style="margin-top: 1.5rem; margin-left: 1.5rem">
              <span
                class="bodyText"
                [style.color]="
                  projectSetupForm.controls['softwareProjectOverviewField']
                    ?.touched &&
                  projectSetupForm.controls['softwareProjectOverviewField']
                    ?.errors?.required
                    ? '#9e1b32'
                    : ''
                "
                >Describe the software development work needed for this
                effort:</span
              >
            </div>
            <div style="margin-top: 0.688rem; margin-left: 1.5rem">
              <textarea
                [(ngModel)]="softwareProjectOverviewCopy"
                class="softwareProjectOverviewTextBox"
                style="height: 4rem; width: 45.375rem; border-color: #26bcd7"
                maxlength="255"
                required
                name="softwareProjectOverviewField"
              ></textarea>
            </div>
            <div>
              <span
                style="
                  color: #696969;
                  font-style: italic;
                  float: right;
                  position: absolute;
                  right: 42.813rem;
                "
                >{{ softwareProjectLength() }} / 255 characters</span
              >
            </div>
            <div style="width: 50.938rem">
              <div
                style="
                  display: inline-block;
                  margin-top: 1.5rem;
                  margin-left: 1.5rem;
                  width: 37.688rem;
                "
              >
                <span
                  class="bodyText"
                  [style.color]="
                    projectSetupForm.controls['dataConversionActivitiesField']
                      ?.touched &&
                    projectSetupForm.controls['dataConversionActivitiesField']
                      ?.errors?.required
                      ? '#9e1b32'
                      : ''
                  "
                  >Will you have data conversion activities? (If yes, the cost
                  of running processes or manually cleaning up data should be
                  included in O&M estimate; only development of data conversion
                  software can be capitalized)</span
                >
              </div>
              <div
                style="
                  display: inline-block;
                  margin-top: 1.5rem;
                  vertical-align: top;
                  float: right;
                "
              >
                <mat-radio-group
                  [(ngModel)]="dataConversionActivitiesCopy"
                  required
                  name="dataConversionActivitiesField"
                >
                  <mat-radio-button color="primary" [value]="'YES'">
                    <span class="choiceText">YES</span>
                  </mat-radio-button>
                  <mat-radio-button
                    color="primary"
                    [value]="'NO'"
                    style="margin-left: 1.125rem"
                  >
                    <span class="choiceText">NO</span>
                  </mat-radio-button>
                </mat-radio-group>
              </div>
            </div>
            <div style="width: 50.938rem">
              <div
                style="
                  display: inline-block;
                  margin-top: 1.5rem;
                  margin-left: 1.5rem;
                  width: 37.688rem;
                "
              >
                <span
                  class="bodyText"
                  [style.color]="
                    projectSetupForm.controls['trainingCostsField']?.touched &&
                    projectSetupForm.controls['trainingCostsField']?.errors
                      ?.required
                      ? '#9e1b32'
                      : ''
                  "
                  >Will you have training costs? (If yes, the cost of
                  train-the-trainer and user training should be included in O&M
                  estimate; only developer training on how to develop the
                  software can be capitalized)</span
                >
              </div>
              <div
                style="
                  display: inline-block;
                  margin-top: 1.5rem;
                  vertical-align: top;
                  float: right;
                "
              >
                <mat-radio-group
                  [(ngModel)]="trainingCostsCopy"
                  required
                  name="trainingCostsField"
                >
                  <mat-radio-button color="primary" [value]="'YES'">
                    <span class="choiceText">YES</span>
                  </mat-radio-button>
                  <mat-radio-button
                    color="primary"
                    [value]="'NO'"
                    style="margin-left: 1.125rem"
                  >
                    <span class="choiceText">NO</span>
                  </mat-radio-button>
                </mat-radio-group>
              </div>
            </div>
            <div style="width: 50.938rem">
              <div
                style="
                  display: inline-block;
                  margin-top: 1.5rem;
                  margin-left: 1.5rem;
                  width: 37.688rem;
                "
              >
                <span
                  class="bodyText"
                  [style.color]="
                    projectSetupForm.controls['associatedRetirementField']
                      ?.touched &&
                    projectSetupForm.controls['associatedRetirementField']
                      ?.errors?.required
                      ? '#9e1b32'
                      : ''
                  "
                  >Is there an associated retirement of existing software?</span
                >
              </div>
              <div
                style="
                  display: inline-block;
                  margin-top: 1.5rem;
                  vertical-align: top;
                  float: right;
                "
              >
                <mat-radio-group
                  [(ngModel)]="associatedRetirementCopy"
                  required
                  name="associatedRetirementField"
                >
                  <mat-radio-button color="primary" [value]="'YES'">
                    <span class="choiceText">YES</span>
                  </mat-radio-button>
                  <mat-radio-button
                    color="primary"
                    [value]="'NO'"
                    style="margin-left: 1.125rem"
                  >
                    <span class="choiceText">NO</span>
                  </mat-radio-button>
                </mat-radio-group>
              </div>
            </div>
            <div
              *ngIf="associatedRetirementCopy === 'YES'"
              style="display: inline-block"
            >
              <div
                style="
                  display: inline-block;
                  margin-top: 0.688rem;
                  margin-left: 1.5rem;
                "
              >
                <mat-form-field
                  class="itFields"
                  style="
                    width: 19.4rem;
                    padding-left: 0.5rem;
                    padding-right: 0.5rem;
                  "
                >
                  <input
                    [(ngModel)]="softwareToBeRetiredCopy"
                    placeholder="Software To Be Retired"
                    matInput
                    required
                    name="softwareToBeRetiredField"
                  />
                </mat-form-field>
              </div>
              <div
                style="
                  display: inline-block;
                  margin-top: 0.688rem;
                  margin-left: 1.5rem;
                "
              >
                <mat-form-field
                  class="itFields"
                  style="
                    width: 19.4rem;
                    padding-left: 0.5rem;
                    padding-right: 0.5rem;
                  "
                >
                  <input
                    [(ngModel)]="retiredInServiceDateCopy"
                    placeholder="When was it in service?"
                    matInput
                    name="retiredInServiceDateField"
                  />
                </mat-form-field>
              </div>
            </div>
            <div style="width: 50.938rem">
              <div
                style="
                  display: inline-block;
                  margin-top: 1.5rem;
                  margin-left: 1.5rem;
                  width: 37.688rem;
                "
              >
                <span
                  class="bodyText"
                  [style.color]="
                    projectSetupForm.controls['maintenanceContractsField']
                      ?.touched &&
                    projectSetupForm.controls['maintenanceContractsField']
                      ?.errors?.required
                      ? '#9e1b32'
                      : ''
                  "
                  >Will you have any maintenance contracts/agreements?</span
                >
              </div>
              <div
                [class.moveDown]="associatedRetirementCopy === 'YES'"
                style="
                  display: inline-block;
                  margin-top: 1.5rem;
                  vertical-align: top;
                  float: right;
                  position: relative;
                  top: -3.313rem;
                "
              >
                <mat-radio-group
                  [(ngModel)]="maintenanceContractsCopy"
                  required
                  name="maintenanceContractsField"
                >
                  <mat-radio-button color="primary" [value]="'YES'">
                    <span class="choiceText">YES</span>
                  </mat-radio-button>
                  <mat-radio-button
                    color="primary"
                    [value]="'NO'"
                    style="margin-left: 1.125rem"
                  >
                    <span class="choiceText">NO</span>
                  </mat-radio-button>
                </mat-radio-group>
              </div>
            </div>
            <div style="width: 50.938rem">
              <div
                style="
                  display: inline-block;
                  margin-top: 1.5rem;
                  margin-left: 1.5rem;
                  width: 37.688rem;
                "
              >
                <span
                  class="bodyText"
                  [style.color]="
                    projectSetupForm.controls['replacingInterfacesField']
                      ?.touched &&
                    projectSetupForm.controls['replacingInterfacesField']
                      ?.errors?.required
                      ? '#9e1b32'
                      : ''
                  "
                  >Are you replacing any existing interfaces?</span
                >
              </div>
              <div
                [class.moveLeft]="associatedRetirementCopy === 'YES'"
                style="
                  display: inline-block;
                  margin-top: 1.5rem;
                  vertical-align: top;
                  float: right;
                  position: relative;
                  top: -3.313rem;
                  left: 7.48rem;
                "
              >
                <mat-radio-group
                  [(ngModel)]="replacingInterfacesCopy"
                  required
                  name="replacingInterfacesField"
                >
                  <mat-radio-button color="primary" [value]="'YES'">
                    <span class="choiceText">YES</span>
                  </mat-radio-button>
                  <mat-radio-button
                    color="primary"
                    [value]="'NO'"
                    style="margin-left: 1.125rem"
                  >
                    <span class="choiceText">NO</span>
                  </mat-radio-button>
                </mat-radio-group>
              </div>
            </div>
            <div>
              <mat-form-field
                class="itFields"
                style="
                  margin-top: 1.5rem;
                  margin-left: 1.5rem;
                  margin-bottom: 1.5rem;
                  width: 30.938rem;
                  padding-left: 0.5rem;
                  padding-right: 0.5rem;
                "
              >
                <mat-select
                  [(ngModel)]="howSoftwareReleasedCopy"
                  placeholder="How will the software be released?"
                  required
                  name="howSoftwareReleasedsField"
                >
                  <mat-option
                    *ngFor="let option of howSoftwareReleasedOptions"
                    style="color: #696969"
                    [value]="option"
                    ><span>{{ option }}</span></mat-option
                  >
                </mat-select>
              </mat-form-field>
            </div>
            <div *ngIf="isVendorHosted()" style="width: 50.938rem">
              <div
                style="
                  display: inline-block;
                  margin-left: 1.5rem;
                  width: 37.688rem;
                "
              >
                <span
                  class="bodyText"
                  [style.color]="
                    projectSetupForm.controls['perpetualLicensesField']
                      ?.touched &&
                    projectSetupForm.controls['perpetualLicensesField']?.errors
                      ?.required
                      ? '#9e1b32'
                      : ''
                  "
                  >Will Duke own perpetual licenses?</span
                >
              </div>
              <div
                style="
                  display: inline-block;
                  vertical-align: top;
                  float: right;
                  position: relative;
                "
              >
                <mat-radio-group
                  [(ngModel)]="perpetualLicensesCopy"
                  required
                  name="perpetualLicensesField"
                >
                  <mat-radio-button color="primary" [value]="'YES'">
                    <span class="choiceText">YES</span>
                  </mat-radio-button>
                  <mat-radio-button
                    color="primary"
                    [value]="'NO'"
                    style="margin-left: 1.125rem"
                  >
                    <span class="choiceText">NO</span>
                  </mat-radio-button>
                </mat-radio-group>
              </div>
            </div>
            <div *ngIf="isVendorHosted()" style="width: 50.938rem">
              <div
                style="
                  display: inline-block;
                  margin-top: 1.5rem;
                  margin-left: 1.5rem;
                  width: 36.688rem;
                "
              >
                <span
                  class="bodyText"
                  [style.color]="
                    projectSetupForm.controls['contractualRightField']
                      ?.touched &&
                    projectSetupForm.controls['contractualRightField']?.errors
                      ?.required
                      ? '#9e1b32'
                      : ''
                  "
                  >Does Duke have the contractual right to take possession of
                  the software at any time during the arrangement period?</span
                >
              </div>
              <div
                style="
                  display: inline-block;
                  margin-top: 1.5rem;
                  vertical-align: top;
                  float: right;
                  position: relative;
                  top: -3.313rem;
                "
              >
                <mat-radio-group
                  [(ngModel)]="contractualRightCopy"
                  required
                  name="contractualRightField"
                >
                  <mat-radio-button color="primary" [value]="'YES'">
                    <span class="choiceText">YES</span>
                  </mat-radio-button>
                  <mat-radio-button
                    color="primary"
                    [value]="'NO'"
                    style="margin-left: 1.125rem"
                  >
                    <span class="choiceText">NO</span>
                  </mat-radio-button>
                </mat-radio-group>
              </div>
            </div>
            <div *ngIf="isVendorHosted()" style="width: 50.938rem">
              <div
                style="
                  display: inline-block;
                  margin-top: 1.5rem;
                  margin-left: 1.5rem;
                  width: 37.688rem;
                "
              >
                <span
                  class="bodyText"
                  [style.color]="
                    projectSetupForm.controls['significantPenaltytField']
                      ?.touched &&
                    projectSetupForm.controls['significantPenaltytField']
                      ?.errors?.required
                      ? '#9e1b32'
                      : ''
                  "
                  >Is there a significant penalty to take possession of the
                  software and bring it in house? (Significant penalty is
                  interpreted as either a significant cost or significant
                  reduction in value or functionality when taking possession of
                  the software. Significant cost is defined as greater than 15%
                  of the total capital cost of the project)</span
                >
              </div>
              <div
                style="
                  display: inline-block;
                  margin-top: 1.5rem;
                  vertical-align: top;
                  float: right;
                  position: relative;
                  top: -6.313rem;
                "
              >
                <mat-radio-group
                  [(ngModel)]="significantPenaltyCopy"
                  required
                  name="significantPenaltytField"
                >
                  <mat-radio-button color="primary" [value]="'YES'">
                    <span class="choiceText">YES</span>
                  </mat-radio-button>
                  <mat-radio-button
                    color="primary"
                    [value]="'NO'"
                    style="margin-left: 1.125rem"
                  >
                    <span class="choiceText">NO</span>
                  </mat-radio-button>
                </mat-radio-group>
              </div>
            </div>
            <div *ngIf="isVendorHosted()" style="width: 50.938rem">
              <div
                style="
                  display: inline-block;
                  margin-top: 1.5rem;
                  margin-left: 1.5rem;
                  width: 34.688rem;
                "
              >
                <span
                  class="bodyText"
                  [style.color]="
                    projectSetupForm.controls['isFeasibleField']?.touched &&
                    projectSetupForm.controls['isFeasibleField']?.errors
                      ?.required
                      ? '#9e1b32'
                      : ''
                  "
                  >Is it feasible for Duke to run the software on our own
                  hardware or to contract with another third party host?</span
                >
              </div>
              <div
                style="
                  display: inline-block;
                  margin-top: 0.5rem;
                  vertical-align: top;
                  float: right;
                  position: relative;
                  top: -3.313rem;
                "
              >
                <mat-radio-group
                  [(ngModel)]="isFeasibleCopy"
                  required
                  name="isFeasibleField"
                >
                  <mat-radio-button color="primary" [value]="'YES'">
                    <span class="choiceText">YES</span>
                  </mat-radio-button>
                  <mat-radio-button
                    color="primary"
                    [value]="'NO'"
                    style="margin-left: 1.125rem"
                  >
                    <span class="choiceText">NO</span>
                  </mat-radio-button>
                </mat-radio-group>
              </div>
            </div>
            <div *ngIf="isVendorHosted()" style="width: 50.938rem">
              <div
                style="
                  display: inline-block;
                  margin-top: 1.5rem;
                  margin-left: 1.5rem;
                  width: 37.688rem;
                "
              >
                <span
                  class="bodyText"
                  [style.color]="
                    projectSetupForm.controls['serviceFeesField']?.touched &&
                    projectSetupForm.controls['serviceFeesField']?.errors
                      ?.required
                      ? '#9e1b32'
                      : ''
                  "
                  >Are there service or usage fees?</span
                >
              </div>
              <div
                style="
                  display: inline-block;
                  margin-top: 1.5rem;
                  vertical-align: top;
                  float: right;
                  position: relative;
                  top: -3.313rem;
                "
              >
                <mat-radio-group
                  [(ngModel)]="serviceFeesCopy"
                  required
                  name="serviceFeesField"
                >
                  <mat-radio-button color="primary" [value]="'YES'">
                    <span class="choiceText">YES</span>
                  </mat-radio-button>
                  <mat-radio-button
                    color="primary"
                    [value]="'NO'"
                    style="margin-left: 1.125rem"
                  >
                    <span class="choiceText">NO</span>
                  </mat-radio-button>
                </mat-radio-group>
              </div>
            </div>
            <div *ngIf="isVendorHosted()" style="width: 50.938rem">
              <div
                style="
                  display: inline-block;
                  margin-top: 1.5rem;
                  margin-left: 1.5rem;
                  margin-bottom: 1.5rem;
                  width: 37.688rem;
                "
              >
                <span
                  class="bodyText"
                  [style.color]="
                    projectSetupForm.controls['useWithoutPayingField']
                      ?.touched &&
                    projectSetupForm.controls['useWithoutPayingField']?.errors
                      ?.required
                      ? '#9e1b32'
                      : ''
                  "
                  >If we stop paying the service or usage fees, can we still use
                  the software?</span
                >
              </div>
              <div
                style="
                  display: inline-block;
                  vertical-align: top;
                  float: right;
                  position: relative;
                  top: -3.313rem;
                "
              >
                <mat-radio-group
                  [(ngModel)]="useWithoutPayingCopy"
                  required
                  name="useWithoutPayingField"
                >
                  <mat-radio-button color="primary" [value]="'YES'">
                    <span class="choiceText">YES</span>
                  </mat-radio-button>
                  <mat-radio-button
                    color="primary"
                    [value]="'NO'"
                    style="margin-left: 1.125rem"
                  >
                    <span class="choiceText">NO</span>
                  </mat-radio-button>
                </mat-radio-group>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
    <div style="margin-top: 2.625rem">
      <span class="itProjectHeader" style="font-size: 1.313rem">Page Two</span>
    </div>
    <form
      #projectEstimateForm="ngForm"
      (keydown.enter)="$event.preventDefault()"
    >
      <div style="display: inline-block; margin-top: 1.5rem">
        <div *ngIf="!editFormMode" style="width: 23.438rem; height: 6.25rem">
          <div style="display: inline-block; margin-top: 1.125rem">
            <mat-form-field class="itFields" style="width: 19.4rem">
              <input
                readonly="true"
                type="text"
                placeholder="Who will this work benefit?"
                matInput
                [(ngModel)]="department.department"
                name="department"
              />
            </mat-form-field>
          </div>
        </div>
        <div
          *ngIf="editFormMode"
          style="width: 23.438rem; height: 6.25rem; background-color: #f3fafd"
        >
          <div
            style="
              display: inline-block;
              margin-top: 1.125rem;
              margin-left: 1.5rem;
            "
          >
            <mat-form-field
              class="itFields"
              style="
                width: 19.4rem;
                padding-left: 0.5rem;
                padding-right: 0.5rem;
              "
            >
              <mat-select
                [(ngModel)]="departmentCopy"
                placeholder="Who will this work benefit?"
                (selectionChange)="
                  deleteDefaultOption(); assignAllocationDefaults($event.value)
                "
                required
                name="departmentCopy"
                [compareWith]="compareDepartment"
              >
                <mat-option
                  *ngFor="let option of defaultsByDepartment"
                  style="color: #696969"
                  [value]="option"
                  ><span>{{ option.department }}</span></mat-option
                >
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>
      <div style="display: inline-block; margin-top: 1.5rem">
        <div *ngIf="!editFormMode" style="width: 38.438rem; height: 6.25rem">
          <div
            style="
              display: inline-block;
              margin-top: 1.125rem;
              margin-left: 1.5rem;
            "
          >
            <mat-form-field class="itFields" style="width: 34.563rem">
              <input
                readonly="true"
                type="text"
                placeholder="Building Info (Building Name)"
                matInput
                [(ngModel)]="buildingInfo.BuildingName"
                name="buildingInfo"
              />
            </mat-form-field>
          </div>
        </div>
        <div
          *ngIf="editFormMode"
          style="width: 38.438rem; height: 6.25rem; background-color: #f3fafd"
        >
          <div
            style="
              display: inline-block;
              margin-top: 1.125rem;
              margin-left: 1.5rem;
            "
          >
            <mat-form-field
              *ngIf="!(buildingInfoCopy && buildingInfoCopy.BuildingName)"
              class="itFields"
              style="
                width: 34.563rem;
                padding-left: 0.5rem;
                padding-right: 0.5rem;
              "
            >
              <input
                type="text"
                placeholder="Building Info (Building Name)"
                matAutocompletePosition="below"
                matInput
                [matAutocomplete]="auto1"
                [formControl]="buildingInfoControl"
                [(ngModel)]="buildingInfoCopy"
                required
                name="buildingInfoField"
              />
            </mat-form-field>
            <mat-form-field
              *ngIf="buildingInfoCopy && buildingInfoCopy.BuildingName"
              class="itFields"
              style="
                width: 34.563rem;
                padding-left: 0.5rem;
                padding-right: 0.5rem;
              "
            >
              <input
                type="text"
                placeholder="Building Info (Building Name)"
                matAutocompletePosition="below"
                matInput
                [matAutocomplete]="auto1"
                [formControl]="buildingInfoControl"
                [(ngModel)]="buildingInfoCopy"
                readonly="true"
              />
            </mat-form-field>
            <mat-autocomplete
              #auto1="matAutocomplete"
              [displayWith]="displayFnBuildingInfo"
              (optionSelected)="assignBuilding($event.option.value)"
            >
              <mat-option
                *ngFor="let option of filteredBuildingInfoOptions | async"
                style="color: #696969"
                [value]="option"
                ><span>{{ option.BuildingName }}</span></mat-option
              >
            </mat-autocomplete>
            <div
              *ngIf="buildingInfoCopy && buildingInfoCopy.BuildingName"
              style="
                display: inline-block;
                padding-top: 0.8rem;
                z-index: 0;
                position: absolute;
              "
            >
              <img
                (click)="deleteBuildingInfo()"
                style="margin-left: -1.5rem; cursor: pointer"
                src="assets/close-window.svg"
              />
            </div>
          </div>
        </div>
      </div>
      <div
        *ngIf="
          !(
            hardwareOrSoftwareCopy === 'Hardware Only' ||
            hardwareOrSoftwareCopy === 'O&M Only'
          )
        "
        style="margin-top: 1.5rem; margin-bottom: 0.5rem"
      >
        <span class="projectScopeHeader">Release Details</span>
      </div>
      <div
        *ngIf="
          !(
            hardwareOrSoftwareCopy === 'Hardware Only' ||
            hardwareOrSoftwareCopy === 'O&M Only'
          )
        "
        style="padding-top: 1.5rem; width: 78rem"
      >
        <div style="width: 78rem; margin-bottom: 1.5rem; text-align: center">
          <span class="projectScopeHeader">Capability and Release Details</span>
        </div>
        <div style="height: 0.1rem; background-color: #f5f5f5"></div>
      </div>
      <div>
        <div
          *ngIf="
            !editFormMode &&
            !(
              hardwareOrSoftwareCopy === 'Hardware Only' ||
              hardwareOrSoftwareCopy === 'O&M Only'
            )
          "
        >
          <div *ngFor="let releaseDetail of releaseDetails; let i = index">
            <div
              *ngFor="
                let capabilityDetail of releaseDetail.capabilityDetails;
                let j = index;
                let jindex = index
              "
            >
              <div style="width: 78rem; height: 6.25rem">
                <div
                  style="
                    display: inline-block;
                    margin-top: 1.125rem;
                    margin-left: 1.5rem;
                  "
                >
                  <mat-form-field class="itFields" style="width: 6rem">
                    <input
                      readonly="true"
                      [(ngModel)]="capabilityDetail.releaseNumber"
                      placeholder="Release #"
                      matInput
                      [name]="'releaseNumber' + i + jindex"
                    />
                  </mat-form-field>
                </div>
                <div
                  style="
                    display: inline-block;
                    margin-top: 1.125rem;
                    margin-left: 0.5rem;
                  "
                >
                  <mat-form-field
                    style="
                      background: white;
                      padding-left: 0.4rem;
                      padding-right: 0.4rem;
                      margin-top: 1.125rem;
                      width: 7.1rem;
                      height: 4rem;
                    "
                  >
                    <mat-label>Release Date</mat-label>
                    <input
                      readonly="true"
                      matInput
                      [matDatepicker]="j"
                      [(ngModel)]="capabilityDetail.releaseDate"
                      style="color: #696969"
                      [name]="'releaseDate' + i + jindex"
                    />
                    <mat-datepicker #j></mat-datepicker>
                  </mat-form-field>
                </div>
                <div
                  style="
                    display: inline-block;
                    margin-top: 1.125rem;
                    margin-left: 0.5rem;
                  "
                >
                  <mat-form-field
                    class="itFields"
                    style="width: 19.138rem; cursor: pointer"
                    (click)="openCapabilityDialog(i, jindex, true)"
                  >
                    <input
                      readonly="true"
                      style="pointer-events: none"
                      [(ngModel)]="capabilityDetail.capabilities"
                      placeholder="Capability"
                      matInput
                      [name]="'capabilities' + i + jindex"
                    />
                  </mat-form-field>
                </div>
                <div
                  style="
                    display: inline-block;
                    margin-top: 1.125rem;
                    margin-left: 0.5rem;
                  "
                >
                  <mat-form-field
                    class="itFields"
                    style="width: 19.138rem; cursor: pointer"
                    (click)="openCapabilityDialog(i, jindex, true)"
                  >
                    <input
                      readonly="true"
                      style="pointer-events: none"
                      [(ngModel)]="capabilityDetail.description"
                      placeholder="Detailed Description of Capability"
                      matInput
                      [name]="'description' + i + jindex"
                    />
                  </mat-form-field>
                </div>
                <div
                  style="
                    display: inline-block;
                    margin-top: 1.125rem;
                    margin-left: 0.5rem;
                  "
                >
                  <mat-form-field
                    class="itFields"
                    style="width: 6rem"
                    [floatLabel]="'always'"
                  >
                    <input
                      readonly="true"
                      type="text"
                      [ngModel]="
                        +capabilityDetail.capitalCost
                          | CurrencyUSD : 'USD' : true : false
                      "
                      placeholder="Capital Cost"
                      matInput
                      [name]="'capabilityDetail.capitalCost' + i + jindex"
                    />
                  </mat-form-field>
                </div>
                <div
                  style="
                    display: inline-block;
                    margin-top: 1.125rem;
                    margin-left: 0.5rem;
                  "
                >
                  <mat-form-field
                    class="itFields"
                    style="width: 6rem"
                    [floatLabel]="'always'"
                  >
                    <input
                      readonly="true"
                      type="text"
                      [ngModel]="
                        +capabilityDetail.omCost
                          | CurrencyUSD : 'USD' : true : false
                      "
                      placeholder="O&M Cost"
                      matInput
                      [name]="'capabilityDetail' + i + jindex"
                    />
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>
          <div
            style="height: 0.1rem; background-color: #f5f5f5; width: 78rem"
          ></div>
        </div>
        <div
          *ngIf="
            editFormMode &&
            !(
              hardwareOrSoftwareCopy === 'Hardware Only' ||
              hardwareOrSoftwareCopy === 'O&M Only'
            )
          "
        >
          <div *ngFor="let releaseDetail of releaseDetailsCopy; let i = index">
            <div
              *ngFor="
                let capabilityDetail of releaseDetail.capabilityDetails;
                let j = index;
                let jindex = index
              "
            >
              <div
                style="width: 78rem; height: 6.25rem"
                [class.backgroundColorBlue]="!isOdd(i)"
                [class.backgroundColorGray]="isOdd(i)"
              >
                <div
                  style="
                    display: inline-block;
                    margin-top: 1.125rem;
                    margin-left: 1.5rem;
                  "
                >
                  <mat-form-field
                    *ngIf="jindex !== 0"
                    class="itFields"
                    [class.backgroundBlue]="!isOdd(i)"
                    [class.backgroundGray]="isOdd(i)"
                    style="
                      width: 6rem;
                      padding-left: 0.5rem;
                      padding-right: 0.5rem;
                    "
                  >
                    <input
                      [(ngModel)]="capabilityDetail.releaseNumber"
                      placeholder="Release #"
                      matInput
                      readonly="true"
                      (change)="releaseNumberChange(i, jindex)"
                      required
                      [name]="
                        'releaseDetail.capabilityDetail.releaseNumberField' +
                        i +
                        jindex
                      "
                    />
                  </mat-form-field>
                  <mat-form-field
                    *ngIf="jindex === 0"
                    class="itFields"
                    style="
                      width: 6rem;
                      padding-left: 0.5rem;
                      padding-right: 0.5rem;
                    "
                  >
                    <input
                      [(ngModel)]="capabilityDetail.releaseNumber"
                      placeholder="Release #"
                      matInput
                      (change)="releaseNumberChange(i, jindex)"
                      required
                      [name]="
                        'releaseDetail.capabilityDetail.releaseNumberField' +
                        i +
                        jindex
                      "
                    />
                  </mat-form-field>
                </div>
                <div
                  style="
                    display: inline-block;
                    margin-top: 1.125rem;
                    margin-left: 0.5rem;
                  "
                >
                  <mat-form-field
                    *ngIf="jindex !== 0"
                    [class.backgroundBlue]="!isOdd(i)"
                    [class.backgroundGray]="isOdd(i)"
                    style="
                      background: white;
                      padding-left: 0.4rem;
                      padding-right: 0.4rem;
                      margin-top: 1.125rem;
                      width: 7.1rem;
                      height: 4rem;
                      pointer-events: none;
                    "
                  >
                    <mat-label>Release Date</mat-label>
                    <input
                      matInput
                      [matDatepicker]="j"
                      [(ngModel)]="capabilityDetail.releaseDate"
                      style="color: #696969"
                      [min]="estimatedStartDateCopy"
                      [max]="estimatedInServiceDateCopy"
                      readonly="true"
                      (dateChange)="releaseDateChange(i, jindex)"
                      required
                      [name]="
                        'releaseDetail.capabilityDetail.releaseDateField' +
                        i +
                        jindex
                      "
                    />
                    <mat-datepicker-toggle
                      matSuffix
                      [for]="j"
                    ></mat-datepicker-toggle>
                    <mat-datepicker #j></mat-datepicker>
                  </mat-form-field>
                  <mat-form-field
                    *ngIf="jindex === 0"
                    style="
                      background: white;
                      padding-left: 0.4rem;
                      padding-right: 0.4rem;
                      margin-top: 1.125rem;
                      width: 7.1rem;
                      height: 4rem;
                    "
                  >
                    <mat-label>Release Date</mat-label>
                    <input
                      matInput
                      [matDatepicker]="j"
                      [(ngModel)]="capabilityDetail.releaseDate"
                      style="color: #696969"
                      [min]="estimatedStartDateCopy"
                      [max]="estimatedInServiceDateCopy"
                      (dateChange)="releaseDateChange(i, jindex)"
                      required
                      [name]="
                        'releaseDetail.capabilityDetail.releaseDateField' +
                        i +
                        jindex
                      "
                    />
                    <mat-datepicker-toggle
                      matSuffix
                      [for]="j"
                    ></mat-datepicker-toggle>
                    <mat-datepicker #j></mat-datepicker>
                  </mat-form-field>
                </div>
                <div
                  style="
                    display: inline-block;
                    margin-top: 1.125rem;
                    margin-left: 0.5rem;
                  "
                >
                  <mat-form-field
                    class="itFields"
                    style="
                      width: 19.138rem;
                      cursor: pointer;
                      padding-left: 0.5rem;
                      padding-right: 0.5rem;
                    "
                    (click)="openCapabilityDialog(i, jindex, false)"
                  >
                    <input
                      readonly="true"
                      style="pointer-events: none"
                      [(ngModel)]="capabilityDetail.capabilities"
                      placeholder="Capability"
                      matInput
                      required
                      [name]="
                        'releaseDetail.capabilityDetail.capabilityField' +
                        i +
                        jindex
                      "
                    />
                  </mat-form-field>
                </div>
                <div
                  style="
                    display: inline-block;
                    margin-top: 1.125rem;
                    margin-left: 0.5rem;
                  "
                >
                  <mat-form-field
                    class="itFields"
                    style="
                      width: 19.138rem;
                      cursor: pointer;
                      padding-left: 0.5rem;
                      padding-right: 0.5rem;
                    "
                    (click)="openCapabilityDialog(i, jindex, false)"
                  >
                    <input
                      readonly="true"
                      style="pointer-events: none"
                      [(ngModel)]="capabilityDetail.description"
                      placeholder="Detailed Description of Capability"
                      matInput
                      [name]="
                        'releaseDetail.capabilityDetail.descriptionField' +
                        i +
                        jindex
                      "
                    />
                  </mat-form-field>
                </div>
                <div
                  style="
                    display: inline-block;
                    margin-top: 1.125rem;
                    margin-left: 0.5rem;
                  "
                >
                  <mat-form-field
                    class="itFields"
                    style="
                      width: 6rem;
                      padding-left: 0.5rem;
                      padding-right: 0.5rem;
                    "
                    [floatLabel]="'always'"
                  >
                    <input
                      appCurrencyMask
                      appNumbersOnly
                      [allowDecimals]="true"
                      onkeypress="return event.charCode != 45"
                      [(ngModel)]="capabilityDetail.capitalCost"
                      placeholder="Capital Cost"
                      matInput
                      [name]="
                        'releaseDetail.capabilityDetail.capitalCostField' +
                        i +
                        jindex
                      "
                    />
                    <span matPrefix>$</span>
                  </mat-form-field>
                </div>
                <div
                  style="
                    display: inline-block;
                    margin-top: 1.125rem;
                    margin-left: 0.5rem;
                  "
                >
                  <mat-form-field
                    class="itFields"
                    style="
                      width: 6rem;
                      padding-left: 0.5rem;
                      padding-right: 0.5rem;
                    "
                    [floatLabel]="'always'"
                  >
                    <input
                      appCurrencyMask
                      appNumbersOnly
                      [allowDecimals]="true"
                      onkeypress="return event.charCode != 45"
                      [(ngModel)]="capabilityDetail.omCost"
                      placeholder="O&M Cost"
                      matInput
                      [name]="
                        'releaseDetail.capabilityDetail.OMCostField' +
                        i +
                        jindex
                      "
                    />
                    <span matPrefix>$</span>
                  </mat-form-field>
                </div>
                <div
                  style="
                    display: inline-block;
                    margin-top: 1.125rem;
                    margin-right: 0.5rem;
                  "
                >
                  <img
                    style="
                      cursor: pointer;
                      width: 1rem;
                      height: 1rem;
                      padding-left: 2.5rem;
                    "
                    src="assets/trash-bin-base.svg"
                    (click)="deleteRelease(i, jindex)"
                  />
                </div>
              </div>
            </div>
            <div>
              <div
                style="width: 78rem"
                [class.backgroundColorBlue]="!isOdd(i)"
                [class.backgroundColorGray]="isOdd(i)"
              >
                <div
                  style="
                    padding-left: 2rem;
                    padding-top: 1.563rem;
                    padding-bottom: 1.313rem;
                    cursor: pointer;
                    width: 15rem;
                  "
                  (click)="addCapability(i)"
                >
                  <span style="font-weight: bold; font-size: 1.4rem"
                    >&#43;</span
                  >
                  <span
                    style="
                      padding-left: 0.2rem;
                      text-decoration: underline;
                      text-underline-offset: 0.2rem;
                    "
                    >Add a Capability to this Release</span
                  >
                </div>
              </div>
            </div>
          </div>
          <div
            style="height: 0.1rem; background-color: #f5f5f5; width: 78rem"
          ></div>
          <div style="width: 78rem; background-color: #f3fafd">
            <div
              style="
                padding-left: 1rem;
                padding-top: 1.188rem;
                padding-bottom: 1.313rem;
                cursor: pointer;
                width: 15rem;
              "
              (click)="addRelease()"
            >
              <span style="font-weight: bold; font-size: 1.4rem">&#43;</span>
              <span
                style="
                  padding-left: 0.2rem;
                  text-decoration: underline;
                  text-underline-offset: 0.2rem;
                "
                >Add Another Release</span
              >
            </div>
          </div>
        </div>
        <div style="display: inline-block; margin-top: 1.5rem">
          <div style="width: 23.438rem; height: 6.25rem">
            <div
              style="
                display: flex;
                margin-top: 1.125rem;
                gap: 40px;
                width: 50rem;
              "
            >
              <mat-form-field
                *ngIf="editFormMode"
                class="itFields"
                style="width: 22.4rem"
              >
                <mat-select
                  [(ngModel)]="distributeCostCopy"
                  placeholder="How do you want to distribute cost across business?"
                  (selectionChange)="distributeCostChange($event.value)"
                  required
                  name="distributeCostCopy"
                >
                  <mat-option
                    *ngFor="let option of distributeOptions"
                    style="color: #696969"
                    [value]="option"
                    ><span>{{ option }}</span></mat-option
                  >
                </mat-select>
              </mat-form-field>
              <mat-form-field
                *ngIf="!editFormMode"
                class="itFields"
                style="width: 22.4rem"
              >
                <input
                  readonly="true"
                  type="text"
                  placeholder="How do you want to distribute cost across business?"
                  matInput
                  [(ngModel)]="distributeCostCopy"
                  name="distributeCostCopy"
                />
              </mat-form-field>
              <mat-form-field
                class="itFields"
                style="width: 19.4rem"
                *ngIf="
                  editFormMode &&
                  !(
                    distributeCostCopy !== 'Default' ||
                    !(departmentCopy && departmentCopy.department)
                  )
                "
              >
                <mat-select
                  [(ngModel)]="defaultOptionCopy"
                  placeholder="Please select one of the default options:"
                  (selectionChange)="
                    setDefaultAllocation($event.value);
                    setAllocationsAsTouched()
                  "
                  required
                  name="defaultOptionCopy"
                >
                  <mat-option
                    *ngFor="let option of allocationDefaultsCopy"
                    style="color: #696969"
                    [value]="option"
                    ><span>{{ option }}</span></mat-option
                  >
                </mat-select>
              </mat-form-field>
              <mat-form-field
                *ngIf="!editFormMode && defaultOptionCopy"
                class="itFields"
                style="width: 19.4rem"
              >
                <input
                  readonly="true"
                  type="text"
                  placeholder="Please select one of the default options:"
                  matInput
                  [(ngModel)]="defaultOptionCopy"
                  name="defaultOptionCopy"
                />
              </mat-form-field>
            </div>
          </div>
        </div>
        <div style="margin-top: 1.5rem; margin-bottom: 0.5rem">
          <span class="projectScopeHeader">Allocations</span>
        </div>
        <div *ngIf="!editFormMode">
          <div *ngFor="let allocation of allocations; let i = index">
            <div
              style="height: 6.25rem"
              [ngStyle]="{
                width: isAllocationFunctionVisible(allocations)
                  ? '90rem'
                  : '78rem'
              }"
            >
              <div
                style="
                  display: inline-block;
                  margin-top: 1.125rem;
                  margin-left: 1.5rem;
                "
              >
                <mat-form-field class="itFields" style="width: 21.563rem">
                  <input
                    readonly="true"
                    type="text"
                    placeholder="Operating Unit"
                    matInput
                    [(ngModel)]="allocation.displayOperatingUnit"
                    [name]="'allocationOperatingUnit' + i"
                  />
                </mat-form-field>
              </div>
              <div
                style="
                  display: inline-block;
                  margin-top: 1.125rem;
                  margin-left: 0.683rem;
                "
              >
                <mat-form-field class="itFields" style="width: 21.563rem">
                  <input
                    readonly="true"
                    [(ngModel)]="allocation.businessUnit"
                    placeholder="Business Unit"
                    matInput
                    [name]="'allocationBusinessUnit' + i"
                  />
                </mat-form-field>
              </div>
              <div
                style="
                  display: inline-block;
                  margin-top: 1.125rem;
                  margin-left: 0.683rem;
                "
              >
                <mat-form-field class="itFields" style="width: 9.563rem">
                  <input
                    readonly="true"
                    type="text"
                    placeholder="Funding Project ID"
                    matInput
                    [(ngModel)]="allocation.fundingProjectID.work_order_number"
                    [name]="'allocationFundingProjectID' + i"
                  />
                </mat-form-field>
              </div>
              <div
                style="
                  display: inline-block;
                  margin-top: 1.125rem;
                  margin-left: 0.683rem;
                "
              >
                <mat-form-field
                  [class.hiddenElement]="stateDisabled(allocation)"
                  class="itFields"
                  style="width: 6.563rem"
                >
                  <input
                    readonly="true"
                    type="text"
                    placeholder="State"
                    matInput
                    [(ngModel)]="allocation.state"
                    [name]="'allocationState' + i"
                  />
                </mat-form-field>
              </div>
              <div
                [class.removeElement]="
                  !isAllocationFunctionVisible(allocations) &&
                  !showFunctionField(allocation)
                "
                [class.hiddenElement]="!allocation.function"
                style="
                  display: inline-block;
                  margin-top: 1.125rem;
                  margin-left: 0.683rem;
                "
              >
                <mat-form-field class="itFields" style="width: 6.563rem">
                  <input
                    readonly="true"
                    type="text"
                    placeholder="Function"
                    matInput
                    [(ngModel)]="allocation.function"
                    [name]="'allocationFunction' + i"
                  />
                </mat-form-field>
              </div>
              <div
                style="
                  display: inline-block;
                  margin-top: 1.125rem;
                  margin-left: 0.683rem;
                "
              >
                <mat-form-field class="itFields" style="width: 7rem">
                  <input
                    readonly="true"
                    type="text"
                    [ngModel]="allocation.percentage / 100 | percent:'1.0-2'"
                    placeholder="Percentage"
                    [name]="'allocationPercentage' + i"
                    matInput
                    (animationstart)="allocationTotal()"
                    (ngModelChange)="allocationTotal()"
                  />
                </mat-form-field>
              </div>
            </div>
            <div
              style="height: 0.1rem; background-color: #f5f5f5"
              [ngStyle]="{
                width: isAllocationFunctionVisible(allocations)
                  ? '90rem'
                  : '78rem'
              }"
            ></div>
          </div>
        </div>
        <div *ngIf="editFormMode">
          <div *ngFor="let allocation of allocationsCopy; let i = index">
            <div
              style="height: 6.25rem; background-color: #f3fafd"
              [ngStyle]="{
                width: isAllocationFunctionVisible(allocationsCopy)
                  ? '90rem'
                  : '78rem'
              }"
            >
              <div
                style="
                  display: inline-block;
                  margin-top: 1.125rem;
                  margin-left: 1.5rem;
                "
              >
                <mat-form-field
                  class="itFields"
                  style="width: 21.563rem; background-color: #f3fafd"
                >
                  <input
                    type="text"
                    placeholder="Operating Unit"
                    matAutocompletePosition="below"
                    matInput
                    [matAutocomplete]="auto2"
                    [formControl]="operatingUnitControl[i]"
                    [(ngModel)]="allocation.operatingUnit"
                    required
                  />
                </mat-form-field>
                <mat-autocomplete
                  #auto2="matAutocomplete"
                  [displayWith]="displayFnOperatingUnit"
                  (optionSelected)="
                    setBusinessUnit(allocation, $event.option.value, i);
                    getFundingProjectIDChoices(
                      allocation,
                      $event.option.value,
                      i
                    );
                    getUOPDescriptionChoices();
                    setAllocationsAsTouched();
                    updateMatchingBusinessUnits(i)
                  "
                >
                  <mat-option
                    *ngFor="
                      let option of filteredOperatingUnitOptions[i] | async
                    "
                    style="color: #696969"
                    [value]="option"
                    ><span
                      >{{ option.OPERATING_UNIT }} - {{ option.DESCR }}</span
                    ></mat-option
                  >
                </mat-autocomplete>
                <div
                  *ngIf="
                    allocation.operatingUnit &&
                    allocation.operatingUnit.OPERATING_UNIT
                  "
                  style="
                    display: inline-block;
                    padding-top: 0.8rem;
                    z-index: 0;
                    position: absolute;
                  "
                >
                  <img
                    (click)="deleteOperatingUnit(i)"
                    style="margin-left: -1.5rem; cursor: pointer"
                    src="assets/close-window.svg"
                  />
                </div>
              </div>
              <div
                style="
                  display: inline-block;
                  margin-top: 1.125rem;
                  margin-left: 0.683rem;
                "
              >
                <mat-form-field
                  class="itFields"
                  style="width: 21.563rem; background-color: #f3fafd"
                >
                  <input
                    [(ngModel)]="allocation.businessUnit"
                    placeholder="Business Unit"
                    matInput
                    readonly="true"
                    [name]="'allocationBusinessUnitEdit' + i"
                  />
                </mat-form-field>
              </div>
              <div
                style="
                  display: inline-block;
                  margin-top: 1.125rem;
                  margin-left: 0.683rem;
                "
              >
                <mat-form-field
                  [class.removeElement]="
                  allocation.hasFundingError
                  "
                  *ngIf="fundingProjectIDDisabled(allocation, i)"
                  class="itFields"
                  style="
                    width: 9.563rem;
                    background-color: #f3fafd;
                    padding-left: 0.5rem;
                    padding-right: 0.5rem;
                  "
                >
                  <input
                    type="text"
                    placeholder="Funding Project ID"
                    matAutocompletePosition="below"
                    matInput
                    [matAutocomplete]="auto6"
                    [formControl]="fundingProjectControl[i]"
                    [(ngModel)]="allocation.fundingProjectID"
                    required
                    [name]="'allocation.fundingProjectIDField' + i"
                  />
                </mat-form-field>
                <mat-form-field
                  [class.removeElement]="
                    fundingProjectIDDisabled(allocation, i) || allocation.hasFundingError
                  "
                  *ngIf="
                    allocation.fundingProjectID &&
                    allocation.fundingProjectID.work_order_number
                  "
                  class="itFields"
                  style="
                    width: 9.563rem;
                    padding-left: 0.5rem;
                    padding-right: 0.5rem;
                  "
                >
                  <input
                    type="text"
                    placeholder="Funding Project ID"
                    matAutocompletePosition="below"
                    matInput
                    [matAutocomplete]="auto6"
                    [formControl]="fundingProjectControl[i]"
                    [(ngModel)]="allocation.fundingProjectID"
                    required
                    [name]="'allocation.fundingProjectIDField' + i"
                  />
                </mat-form-field>
                <mat-form-field
                  [class.removeElement]="
                    fundingProjectIDDisabled(allocation, i) || allocation.hasFundingError
                  "
                  *ngIf="
                    !(
                      allocation.fundingProjectID &&
                      allocation.fundingProjectID.work_order_number
                    )
                  "
                  class="itFields"
                  style="
                    width: 9.563rem;
                    padding-left: 0.5rem;
                    padding-right: 0.5rem;
                  "
                >
                  <input
                    type="text"
                    placeholder="Funding Project ID"
                    matAutocompletePosition="below"
                    matInput
                    [matAutocomplete]="auto6"
                    [formControl]="fundingProjectControl[i]"
                    [(ngModel)]="allocation.fundingProjectID"
                    required
                    [name]="'allocation.fundingProjectIDField' + i"
                  />
                </mat-form-field>
                <mat-autocomplete
                  [class.removeElement]="
                    fundingProjectIDDisabled(allocation, i) || allocation.hasFundingError
                  "
                  #auto6="matAutocomplete"
                  [displayWith]="displayFnFundingProject"
                  (optionSelected)="updateMatchingBusinessUnits(i)"
                >
                  <mat-option
                    *ngFor="
                      let option of filteredFundingProjectOptions[i] | async
                    "
                    style="color: #696969"
                    [value]="option"
                  >
                    <span>{{ option.work_order_number }}</span>
                  </mat-option>
                </mat-autocomplete>
                <div
                  [class.removeElement]="
                    fundingProjectIDDisabled(allocation, i) || allocation.hasFundingError
                  "
                  *ngIf="
                    allocation.fundingProjectID &&
                    allocation.fundingProjectID.work_order_number
                  "
                  style="
                    display: inline-block;
                    padding-top: 0.8rem;
                    z-index: 0;
                    position: absolute;
                  "
                >
                  <img
                    (click)="deleteFundingProjectID(i)"
                    style="margin-left: -1.5rem; cursor: pointer"
                    src="assets/close-window.svg"
                  />
                </div>
                <div style="padding-left: 0.5rem; padding-right: 0.5rem; width: 9.563rem" *ngIf="allocation.hasFundingError">
                  <span style="color: #9e1b32; font-size: 0.875rem">Projects can not be set up for this business unit</span>
                </div>
              </div>
              <div
                [class.hiddenElement]="stateDisabled(allocation)"
                [ngStyle]="{
                  display:
                    isRepeatedOperatingUnit(i) && !stateDisabled(allocation)
                      ? 'none'
                      : 'inline-block'
                }"
                style="margin-top: 1.125rem; margin-left: 0.683rem"
              >
                <mat-form-field
                  class="itFields"
                  style="
                    width: 6.563rem;
                    padding-left: 0.5rem;
                    padding-right: 0.5rem;
                  "
                >
                  <mat-select
                    [(ngModel)]="allocation.state"
                    placeholder="State"
                    [required]="!stateDisabled(allocation)"
                    [name]="'allocationStateEdit' + i"
                    (selectionChange)="updateMatchingBusinessUnits(i)"
                  >
                    <mat-option
                      *ngFor="let option of allocation.stateOptions"
                      style="color: #696969"
                      [value]="option"
                    >
                      <span>{{ option }}</span>
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div
                [class.removeElement]="
                !isAllocationFunctionVisible(allocationsCopy) &&
                !showFunctionField(allocation)
                "
                [class.hiddenElement]="
                  isAllocationFunctionVisible(allocationsCopy) &&
                  !showFunctionField(allocation)
                "
                [ngStyle]="{
                  display:
                    !isAllocationFunctionVisible(allocationsCopy) &&
                    !showFunctionField(allocation)
                      ? 'none'
                      : 'inline-block'
                }"
                style="margin-top: 1.125rem; margin-left: 0.683rem"
              >
                <mat-form-field class="itFields" style="width: 6.563rem">
                  <mat-select
                    [(ngModel)]="allocation.function"
                    placeholder="Function"
                    [required]="showFunctionField(allocation)"
                    [name]="'allocationFunctionEdit' + i"
                  >
                    <mat-option
                      *ngFor="let option of getAllocationFunctions(allocation)"
                      style="color: #696969"
                      [value]="option"
                      ><span>{{ option }}</span></mat-option
                    >
                  </mat-select>
                </mat-form-field>
              </div>
              <div
                style="
                  display: inline-block;
                  margin-top: 1.125rem;
                  margin-left: 0.683rem;
                "
              >
                <mat-form-field
                  class="itFields"
                  style="
                    width: 7rem;
                    padding-left: 0.5rem;
                    padding-right: 0.5rem;
                  "
                >
                  <input
                    type="number"
                    [min]="0"
                    [max]="100"
                    [step]="0.01"
                    [(ngModel)]="allocation.percentage"
                    (animationstart)="allocationTotal()"
                    (ngModelChange)="allocationTotal()"
                    placeholder="Percentage"
                    matInput
                    required
                    [name]="'allocationPercentage' + i"
                  />
                  <span matSuffix>%</span>
                </mat-form-field>
              </div>
              <div
                style="
                  display: inline-block;
                  margin-top: 1.125rem;
                  margin-right: 0.5rem;
                "
              >
                <img
                  style="
                    cursor: pointer;
                    width: 1rem;
                    height: 1rem;
                    padding-left: 1rem;
                  "
                  src="assets/trash-bin-base.svg"
                  (click)="deleteAllocation(i)"
                />
              </div>
            </div>
            <div
              style="height: 0.1rem; background-color: #f5f5f5"
              [ngStyle]="{
                width: isAllocationFunctionVisible(allocationsCopy)
                  ? '90rem'
                  : '78rem'
              }"
            ></div>
          </div>
          <div
            style="background-color: #f3fafd"
            [ngStyle]="{
              width: isAllocationFunctionVisible(allocationsCopy)
                ? '90rem'
                : '78rem'
            }"
          >
            <div
              style="
                padding-left: 1rem;
                padding-top: 1.188rem;
                padding-bottom: 1.313rem;
                cursor: pointer;
                width: 15rem;
              "
              (click)="addNewAllocation()"
            >
              <span style="font-weight: bold; font-size: 1.4rem">&#43;</span>
              <span
                style="
                  padding-left: 0.2rem;
                  text-decoration: underline;
                  text-underline-offset: 0.2rem;
                "
                >Add New Unit Line</span
              >
            </div>
            <div
              style="
                position: relative;
                float: right;
                margin-top: -4rem;
                margin-right: 3.6rem;
              "
            >
              <div>
                <span style="color: #696969">Total Allocation:</span>
              </div>
              <div>
                <span style="color: #696969; font-weight: bold"
                  >{{ allocationTotalValue }}%</span
                >
              </div>
            </div>
            <div
              [class.removeElement]="!emptyAllocationLine()"
              style="
                text-align: right;
                padding-right: 0.688rem;
                padding-bottom: 0.625rem;
                color: darkred;
              "
            >
              <span
                >Allocation % for an Operating Unit cannot be zero. Please add a
                percentage value or delete the line.</span
              >
            </div>
            <div
              [class.removeElement]="!multipleNuclearHardwareSoftware()"
              style="
                text-align: right;
                padding-right: 0.688rem;
                padding-bottom: 0.625rem;
                color: darkred;
              "
            >
              <span
                >Cannot enter Hardware and Software on a single form when
                allocating across Nuclear Stations. Please change the form to
                either be Hardware or Software, and then enter an additional
                form for the other one.
              </span>
            </div>
            <div
              [class.removeElement]="allocationTotalValue == 100"
              style="
                text-align: right;
                padding-right: 0.688rem;
                padding-bottom: 0.625rem;
                color: darkred;
              "
            >
              <span>Total Allocation must equal 100% in order to proceed</span>
            </div>
            <div
              [class.removeElement]="
                emptyAllocationLine() ||
                duplicateAllocation() ||
                multipleNuclearHardwareSoftware() ||
                sameNuclearSite() ||
                !(allocationTotalValue == 100)
              "
              style="
                text-align: right;
                padding-right: 0.688rem;
                padding-bottom: 0.625rem;
                color: darkred;
              "
            >
              <span></span>
            </div>
          </div>
        </div>
        <div style="width: 78rem">
          <div
            [class.hiddenElement]="true"
            style="
              padding-left: 1rem;
              padding-top: 1.188rem;
              padding-bottom: 1.313rem;
              cursor: pointer;
              width: 15rem;
            "
          >
            <span style="font-weight: bold; font-size: 1.4rem">&#43;</span>
            <span
              style="
                padding-left: 0.2rem;
                text-decoration: underline;
                text-underline-offset: 0.2rem;
              "
              >Add New Unit Line</span
            >
          </div>
          <div
            *ngIf="!editFormMode"
            style="
              position: relative;
              float: right;
              margin-top: -4rem;
              margin-right: 7.6rem;
            "
          >
            <div>
              <span style="color: #696969">Total Allocation:</span>
            </div>
            <div>
              <span style="color: #696969; font-weight: bold"
                >{{ allocationTotalValue }}%</span
              >
            </div>
          </div>
          <div
            *ngIf="!editFormMode && emptyAllocationLine()"
            style="
              text-align: right;
              padding-right: 0.688rem;
              padding-bottom: 0.625rem;
              color: darkred;
            "
          >
            <span
              >Allocation % for an Operating Unit cannot be zero. Please add a
              percentage value.</span
            >
          </div>
          <div
            *ngIf="!editFormMode && allocationTotalValue !== 100"
            style="
              text-align: right;
              padding-right: 0.688rem;
              padding-bottom: 0.625rem;
              color: darkred;
            "
          >
            <span>Total Allocation must equal 100% in order to proceed</span>
          </div>
        </div>
        <div style="margin-top: 1.5rem; margin-bottom: 0.5rem">
          <span class="projectScopeHeader">Estimate Details</span>
        </div>
        <div style="padding-top: 1.5rem; width: 78rem">
          <div style="width: 78rem; margin-bottom: 1.5rem; text-align: center">
            <span class="projectScopeHeader">Material Details</span>
          </div>
          <div style="height: 0.1rem; background-color: #f5f5f5"></div>
        </div>
        <div *ngIf="!editFormMode">
          <div *ngFor="let building of buildings; let i = index">
            <div style="width: 78rem">
              <div style="padding-left: 1.5rem; padding-top: 1.156rem">
                <span class="projectScopeSubHeader">Building</span>
              </div>
              <div
                style="
                  display: inline-block;
                  margin-top: 0.625rem;
                  margin-left: 1.5rem;
                "
              >
                <mat-form-field class="itFields" style="width: 36.75rem">
                  <input
                    readonly="true"
                    type="text"
                    placeholder="Building Name"
                    matInput
                    [(ngModel)]="building.buildingName.BuildingName"
                    [name]="'buildingName' + i"
                  />
                </mat-form-field>
              </div>
              <div
                *ngIf="
                  building.materialEstimates &&
                  building.materialEstimates.length > 0
                "
              >
                <div
                  *ngIf="building.buildingName"
                  style="padding-left: 1.5rem; padding-top: 1.156rem"
                >
                  <span class="projectScopeSubHeader"
                    >Materials for
                    {{ building.buildingName.BuildingName }}</span
                  >
                </div>
                <div
                  *ngIf="!building.buildingName"
                  style="padding-left: 1.5rem; padding-top: 1.156rem"
                >
                  <span class="projectScopeSubHeader">Materials for </span>
                </div>
                <div
                  *ngFor="
                    let estimate of building.materialEstimates;
                    let j = index
                  "
                >
                  <div
                    style="
                      display: inline-block;
                      margin-top: 1.125rem;
                      margin-left: 1.5rem;
                    "
                  >
                    <mat-form-field class="itFields" style="width: 5.625rem">
                      <input
                        readonly="true"
                        type="text"
                        placeholder="Cost"
                        matInput
                        [(ngModel)]="estimate.cost"
                        [name]="'estimateCost' + i + j"
                      />
                    </mat-form-field>
                  </div>
                  <div
                    style="
                      display: inline-block;
                      margin-top: 1.125rem;
                      margin-left: 0.438rem;
                    "
                  >
                    <mat-form-field class="itFields" style="width: 18rem">
                      <input
                        readonly="true"
                        [(ngModel)]="estimate.unitOfPropertyDetails"
                        placeholder="Details"
                        matInput
                        [name]="'unitOfPropertyDetails' + i + j"
                      />
                    </mat-form-field>
                  </div>
                  <div
                    style="
                      display: inline-block;
                      margin-top: 1.125rem;
                      margin-left: 0.438rem;
                    "
                  >
                    <mat-form-field
                      class="itFields"
                      style="width: 24.313rem"
                      [class.hiddenElement]="estimate.cost === 'O&M'"
                    >
                      <input
                        readonly="true"
                        type="text"
                        placeholder="Unit of Property Description"
                        matInput
                        [(ngModel)]="estimate.unitOfPropertyDescription"
                        [name]="'unitOfPropertyDescription' + i + j"
                      />
                    </mat-form-field>
                  </div>
                  <div
                    style="
                      display: inline-block;
                      margin-top: 1.125rem;
                      margin-left: 0.438rem;
                    "
                  >
                    <mat-form-field class="itFields" style="width: 5.625rem">
                      <input
                        readonly="true"
                        type="text"
                        appCurrencyMask
                        [value]="estimate.quantity"
                        placeholder="Quantity"
                        matInput
                      />
                    </mat-form-field>
                  </div>
                  <div
                    style="
                      display: inline-block;
                      margin-top: 1.125rem;
                      margin-left: 0.438rem;
                    "
                  >
                    <mat-form-field
                      class="itFields"
                      style="width: 6rem"
                      [floatLabel]="'always'"
                    >
                      <input
                        readonly="true"
                        type="text"
                        [value]="
                          +estimate.unitCosts
                            | CurrencyUSD : 'USD' : true : false
                        "
                        placeholder="Unit Costs"
                        matInput
                      />
                    </mat-form-field>
                  </div>
                  <div
                    style="
                      display: inline-block;
                      margin-top: 1.125rem;
                      margin-left: 0.438rem;
                    "
                  >
                    <mat-form-field
                      class="itFields"
                      style="width: 6rem"
                      [floatLabel]="'always'"
                    >
                      <input
                        readonly="true"
                        type="text"
                        [value]="
                          +estimate.totalCosts
                            | CurrencyUSD : 'USD' : true : false
                        "
                        placeholder="Total Costs"
                        matInput
                      />
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div
                style="height: 0.1rem; background-color: #f5f5f5; width: 78rem"
              ></div>
            </div>
          </div>
        </div>
        <div *ngIf="editFormMode">
          <div *ngFor="let building of buildingsCopy; let i = index">
            <div
              style="width: 78rem"
              [class.backgroundColorBlue]="!isOdd(i)"
              [class.backgroundColorGray]="isOdd(i)"
            >
              <div style="padding-left: 1.5rem; padding-top: 1.156rem">
                <span class="projectScopeSubHeader">Building</span>
              </div>
              <div
                *ngIf="!isExtraBuilding(building.buildingName)"
                style="
                  display: inline-block;
                  margin-top: 0.625rem;
                  margin-left: 1.5rem;
                "
              >
                <mat-form-field
                  class="itFields"
                  style="
                    width: 36.75rem;
                    padding-left: 0.5rem;
                    padding-right: 0.5rem;
                  "
                >
                  <input
                    type="text"
                    placeholder="Building Name"
                    matAutocompletePosition="below"
                    matInput
                    [matAutocomplete]="auto2"
                    [formControl]="buildingControl[i]"
                    [(ngModel)]="building.buildingName"
                    required
                    [name]="'building.buildingNameField' + i"
                  />
                </mat-form-field>
                <mat-autocomplete
                  #auto2="matAutocomplete"
                  [displayWith]="displayFnBuildingInfo"
                >
                  <mat-option
                    *ngFor="let option of filteredBuildingOptions[i] | async"
                    style="color: #696969"
                    [value]="option"
                    ><span>{{ option.BuildingName }}</span></mat-option
                  >
                </mat-autocomplete>
                <div
                  *ngIf="
                    building &&
                    building.buildingName &&
                    building.buildingName.BuildingName
                  "
                  style="
                    display: inline-block;
                    padding-top: 0.8rem;
                    z-index: 0;
                    position: absolute;
                  "
                >
                  <img
                    (click)="deleteBuildingName(i)"
                    style="margin-left: -1.5rem; cursor: pointer"
                    src="assets/close-window.svg"
                  />
                </div>
              </div>
              <div
                *ngIf="isExtraBuilding(building.buildingName)"
                style="
                  display: inline-block;
                  margin-top: 0.625rem;
                  margin-left: 1.5rem;
                "
              >
                <mat-form-field
                  class="itFields"
                  style="
                    width: 36.75rem;
                    background-color: #f3fafd;
                    padding-left: 0.5rem;
                    padding-right: 0.5rem;
                  "
                >
                  <input
                    type="text"
                    placeholder="Building Name"
                    matInput
                    [(ngModel)]="building.buildingName.BuildingName"
                    readonly="true"
                    required
                    [name]="'building.buildingName.BuildingNameField' + i"
                  />
                </mat-form-field>
              </div>
              <div
                *ngIf="!isExtraBuilding(building.buildingName)"
                style="
                  display: inline-block;
                  margin-top: 1.125rem;
                  margin-right: 0.5rem;
                "
              >
                <img
                  style="
                    cursor: pointer;
                    width: 1rem;
                    height: 1rem;
                    padding-left: 1rem;
                  "
                  src="assets/trash-bin-base.svg"
                  (click)="deleteBuilding(i)"
                />
              </div>
              <div
                *ngIf="!isExtraBuilding(building.buildingName)"
                style="display: inline-block"
              >
                <span class="projectScopeText"
                  >Note: Deleting the building will delete all Material entries
                  associated with it</span
                >
              </div>
              <div
                *ngIf="
                  building.materialEstimates &&
                  building.materialEstimates.length > 0
                "
              >
                <div
                  *ngIf="building.buildingName"
                  style="padding-left: 1.5rem; padding-top: 1.156rem"
                >
                  <span class="projectScopeSubHeader"
                    >Materials for
                    {{ building.buildingName.BuildingName }}</span
                  >
                </div>
                <div
                  *ngIf="!building.buildingName"
                  style="padding-left: 1.5rem; padding-top: 1.156rem"
                >
                  <span class="projectScopeSubHeader">Materials for </span>
                </div>
                <div
                  *ngFor="
                    let estimate of building.materialEstimates;
                    let j = index
                  "
                  [class.adjustForWarning]="
                    j !== 0 &&
                    tangiblePropertyCheck(building.materialEstimates[j - 1])
                  "
                >
                  <div
                    [class.errorBorder]="tangiblePropertyCheck(estimate)"
                    style="
                      display: inline-block;
                      margin-top: 1.125rem;
                      margin-left: 1.5rem;
                    "
                  >
                    <mat-form-field
                      class="itFields"
                      style="
                        width: 5.625rem;
                        padding-left: 0.5rem;
                        padding-right: 0.5rem;
                      "
                    >
                      <mat-select
                        [(ngModel)]="estimate.cost"
                        placeholder="Cost"
                        (selectionChange)="costChanged($event.value, i, j)"
                        [name]="'estimate.cost' + i + j"
                        [required]="
                          isMaterialRequired() || !materialsFilledOut()
                        "
                      >
                        <mat-option
                          *ngFor="let option of costOptions"
                          style="color: #696969"
                          [value]="option"
                          ><span>{{ option }}</span></mat-option
                        >
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div
                    style="
                      display: inline-block;
                      margin-top: 1.125rem;
                      margin-left: 0.438rem;
                    "
                  >
                    <mat-form-field
                      class="itFields"
                      style="
                        width: 18rem;
                        padding-left: 0.5rem;
                        padding-right: 0.5rem;
                      "
                    >
                      <input
                        [(ngModel)]="estimate.unitOfPropertyDetails"
                        placeholder="Details"
                        matInput
                        [name]="'estimate.unitOfPropertyDetailsField' + i + j"
                        [required]="
                          isMaterialRequired() || !materialsFilledOut()
                        "
                      />
                    </mat-form-field>
                  </div>
                  <div
                    style="
                      display: inline-block;
                      margin-top: 1.125rem;
                      margin-left: 0.438rem;
                    "
                    [ngStyle]="{
                      width: estimate.cost !== 'O&M' ? 'auto' : '25.35rem'
                    }"
                  >
                    <mat-form-field
                      class="itFields"
                      style="
                        width: 24.313rem;
                        padding-left: 0.5rem;
                        padding-right: 0.5rem;
                      "
                      *ngIf="estimate.cost !== 'O&M'"
                    >
                      <mat-select
                        [(ngModel)]="estimate.unitOfPropertyDescription"
                        placeholder="Unit of Property Description"
                        [name]="'estimate.unitOfPropertyDescription' + i + j"
                        [required]="
                          isMaterialRequired() || !materialsFilledOut()
                        "
                      >
                        <mat-option
                          *ngFor="let option of uopOptions"
                          style="color: #696969"
                          [value]="option"
                          ><span>{{ option }}</span></mat-option
                        >
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div
                    style="
                      display: inline-block;
                      margin-top: 1.125rem;
                      margin-left: 0.438rem;
                    "
                  >
                    <mat-form-field
                      class="itFields"
                      style="
                        width: 5.625rem;
                        padding-left: 0.5rem;
                        padding-right: 0.5rem;
                      "
                    >
                      <input
                        type="number"
                        [min]="0"
                        onkeypress="return event.charCode != 45"
                        [(ngModel)]="estimate.quantity"
                        placeholder="Quantity"
                        matInput
                        (keyup)="recalculateTotalCost(i, j)"
                        [name]="'estimate.quantityField' + i + j"
                        [required]="
                          isMaterialRequired() || !materialsFilledOut()
                        "
                      />
                    </mat-form-field>
                  </div>
                  <div
                    [class.errorBorder]="
                      tangiblePropertyCheck(estimate) ||
                      (!tangibleTotalCostCheck(estimate) &&
                        tangibleDateCheck(estimate))
                    "
                    style="
                      display: inline-block;
                      margin-top: 1.125rem;
                      margin-left: 0.438rem;
                    "
                  >
                    <mat-form-field
                      class="itFields"
                      style="
                        width: 6rem;
                        padding-left: 0.5rem;
                        padding-right: 0.5rem;
                      "
                      [floatLabel]="'always'"
                    >
                      <input
                        appCurrencyMask
                        appNumbersOnly
                        [allowDecimals]="true"
                        onkeypress="return event.charCode != 45"
                        [(ngModel)]="estimate.unitCosts"
                        placeholder="Unit Costs"
                        matInput
                        (keyup)="recalculateTotalCost(i, j)"
                        [name]="'estimate.unitCostsField' + i + j"
                        [required]="
                          isMaterialRequired() || !materialsFilledOut()
                        "
                      />
                      <span matPrefix>$</span>
                    </mat-form-field>
                  </div>
                  <div
                    [class.errorBorder]="tangibleTotalCostCheck(estimate)"
                    style="
                      display: inline-block;
                      margin-top: 1.125rem;
                      margin-left: 0.438rem;
                    "
                  >
                    <mat-form-field
                      class="itFields"
                      style="
                        width: 6rem;
                        background-color: #f3fafd;
                        padding-left: 0.5rem;
                        padding-right: 0.5rem;
                      "
                      [floatLabel]="'always'"
                    >
                      <input
                        readonly="true"
                        [value]="
                          estimate.totalCosts
                            | CurrencyUSD : 'USD' : true : false
                        "
                        placeholder="Total Costs"
                        matInput
                        [required]="
                          isMaterialRequired() || !materialsFilledOut()
                        "
                        [name]="'estimate.totalCostsField' + i + j"
                      />
                    </mat-form-field>
                  </div>
                  <div
                    style="
                      display: inline-block;
                      margin-top: 1.125rem;
                      margin-right: 0.5rem;
                    "
                  >
                    <img
                      style="
                        cursor: pointer;
                        width: 1rem;
                        height: 1rem;
                        padding-left: 1rem;
                      "
                      src="assets/trash-bin-base.svg"
                      (click)="deleteEstimate(i, j)"
                    />
                  </div>
                  <div
                    *ngIf="tangiblePropertyCheck(estimate)"
                    style="
                      position: absolute;
                      width: 38rem;
                      left: 41.938rem;
                      padding-top: 0.625rem;
                    "
                  >
                    <span style="color: #9e1b32; font-size: 0.875rem"
                      >Tangible (non-software) units of property must have a
                      unit cost of at least $500 to qualify as capital</span
                    >
                  </div>
                  <div
                    *ngIf="tangibleTotalCostCheck(estimate)"
                    style="
                      position: absolute;
                      width: 57rem;
                      left: 22.8rem;
                      padding-top: 0.625rem;
                    "
                  >
                    <span style="color: #9e1b32; font-size: 0.875rem"
                      >If tangible (non-software) units of property have a unit
                      cost between $500 and $999, then the total cost must be at
                      least $50,000 to qualify as capital</span
                    >
                  </div>
                  <div
                    *ngIf="
                      !tangibleTotalCostCheck(estimate) &&
                      tangibleDateCheck(estimate)
                    "
                    style="
                      position: absolute;
                      width: 62rem;
                      left: 17.8rem;
                      padding-top: 0.625rem;
                    "
                  >
                    <span style="color: #9e1b32; font-size: 0.875rem"
                      >If tangible (non-software) units of property have a unit
                      cost between $500 and $999, the work must be scheduled to
                      be done within 12 months to qualify as capital</span
                    >
                  </div>
                </div>
              </div>
              <div
                style="width: 78rem"
                [class.backgroundColorBlue]="!isOdd(i)"
                [class.backgroundColorGray]="isOdd(i)"
              >
                <div
                  style="
                    padding-left: 2rem;
                    padding-top: 1.188rem;
                    padding-bottom: 1.313rem;
                    cursor: pointer;
                    width: 15rem;
                  "
                  (click)="addMaterial(i)"
                >
                  <span style="font-weight: bold; font-size: 1.4rem"
                    >&#43;</span
                  >
                  <span
                    style="
                      padding-left: 0.2rem;
                      text-decoration: underline;
                      text-underline-offset: 0.2rem;
                    "
                    >Add New Material</span
                  >
                </div>
              </div>
              <div
                style="height: 0.1rem; background-color: #f5f5f5; width: 78rem"
              ></div>
            </div>
          </div>
          <div style="width: 78rem; background-color: #f3fafd">
            <div
              [class.noClick]="isExtraBuilding(buildings[0].buildingName)"
              style="
                padding-left: 1rem;
                padding-top: 1.188rem;
                padding-bottom: 1.313rem;
                cursor: pointer;
                width: 15rem;
              "
              (click)="addBuilding()"
            >
              <span
                [class.hiddenElement]="
                  isExtraBuilding(buildings[0].buildingName)
                "
                style="font-weight: bold; font-size: 1.4rem"
                >&#43;</span
              >
              <span
                [class.hiddenElement]="
                  isExtraBuilding(buildings[0].buildingName)
                "
                style="
                  padding-left: 0.2rem;
                  text-decoration: underline;
                  text-underline-offset: 0.2rem;
                "
                >Add Another Building</span
              >
            </div>
          </div>
        </div>
        <div style="width: 78rem; background-color: #f3fafd">
          <div
            *ngIf="!editFormMode"
            style="
              position: relative;
              float: right;
              margin-top: 1.5rem;
              margin-right: 7.3rem;
            "
          >
            <div>
              <span style="color: #696969">Total Estimated:</span>
            </div>
            <div>
              <span style="color: #696969; font-weight: bold"
                >${{
                  buildingTotal().toLocaleString("en", { useGrouping: true })
                }}</span
              >
            </div>
          </div>
          <div
            *ngIf="editFormMode"
            style="
              position: relative;
              float: right;
              margin-top: 1.5rem;
              margin-right: 2rem;
            "
          >
            <div>
              <span style="color: #696969">Total Estimated:</span>
            </div>
            <div>
              <span style="color: #696969; font-weight: bold"
                >${{
                  buildingTotal().toLocaleString("en", { useGrouping: true })
                }}</span
              >
            </div>
          </div>
        </div>
        <div
          style="
            display: inline-block;
            padding-top: 1.5rem;
            width: 78rem;
            margin-top: 0.688rem;
          "
        >
          <div style="width: 78rem; margin-bottom: 1.5rem; text-align: center">
            <span class="projectScopeHeader"
              >Employee/Contractor Labor Details</span
            >
          </div>
          <div style="height: 0.1rem; background-color: #f5f5f5"></div>
        </div>
        <div
          *ngIf="!editFormMode"
          style="width: 78rem; height: 6.25rem; display: inline-block"
        >
          <div *ngFor="let detail of laborDetails; let i = index">
            <div
              style="
                display: inline-block;
                margin-top: 1.125rem;
                margin-left: 1.5rem;
              "
            >
              <mat-form-field class="itFields" style="width: 12rem">
                <input
                  readonly="true"
                  type="text"
                  placeholder="Work Task"
                  matInput
                  [value]="detail.workTask ? detail.workTask.workTask : ''"
                />
              </mat-form-field>
            </div>
            <div
              style="
                display: inline-block;
                margin-top: 1.125rem;
                margin-left: 0.5rem;
              "
            >
              <mat-form-field class="itFields" style="width: 39.875rem">
                <input
                  readonly="true"
                  type="text"
                  placeholder="Work Description"
                  matInput
                  [(ngModel)]="detail.workDescription"
                  [name]="'workDescription' + i"
                />
              </mat-form-field>
            </div>
            <div
              style="
                display: inline-block;
                margin-top: 1.125rem;
                margin-left: 0.5rem;
              "
            >
              <mat-form-field class="itFields" style="width: 9rem">
                <input
                  readonly="true"
                  type="text"
                  placeholder="Charge Type"
                  matInput
                  [(ngModel)]="detail.chargeType"
                  [name]="'chargeType' + i"
                />
              </mat-form-field>
            </div>
            <div
              style="
                display: inline-block;
                margin-top: 1.125rem;
                margin-left: 0.438rem;
              "
            >
              <mat-form-field
                class="itFields"
                style="width: 6rem"
                [floatLabel]="'always'"
              >
                <input
                  readonly="true"
                  type="text"
                  [ngModel]="
                    +detail.totalCosts | CurrencyUSD : 'USD' : true : false
                  "
                  placeholder="Total Costs"
                  matInput
                  [name]="'totalCosts' + i"
                />
              </mat-form-field>
            </div>
          </div>
          <div style="width: 78rem; background-color: #f3fafd">
            <div style="position: relative; float: right; margin-right: 7rem">
              <div>
                <span style="color: #696969">Total Estimated:</span>
              </div>
              <div>
                <span style="color: #696969; font-weight: bold"
                  >${{
                    laborTotal().toLocaleString("en", { useGrouping: true })
                  }}</span
                >
              </div>
            </div>
          </div>
        </div>
        <div
          *ngIf="editFormMode"
          style="
            width: 78rem;
            height: 6.25rem;
            background-color: #f3fafd;
            display: inline-block;
          "
        >
          <div
            *ngFor="let detail of laborDetailsCopy; let i = index"
            style="background-color: #f3fafd"
          >
            <div
              style="
                display: inline-block;
                margin-top: 1.125rem;
                margin-left: 1.5rem;
              "
            >
              <mat-form-field
                class="itFields"
                style="
                  width: 12rem;
                  padding-left: 0.5rem;
                  padding-right: 0.5rem;
                "
              >
                <mat-select
                  [(ngModel)]="detail.workTask"
                  placeholder="Work Task"
                  (selectionChange)="workTaskChanged($event.value, i)"
                  [compareWith]="compareWorkTask"
                  [required]="isEmployeeContractorRequired()"
                  [name]="'laborDetail.workTaskField' + i"
                >
                  <mat-option
                    *ngFor="let option of workTaskOptions"
                    style="color: #696969"
                    [value]="option"
                    ><span>{{ option.workTask }}</span></mat-option
                  >
                </mat-select>
              </mat-form-field>
            </div>
            <div
              style="
                display: inline-block;
                margin-top: 1.125rem;
                margin-left: 0.5rem;
              "
            >
              <mat-form-field
                *ngIf="workDescriptions[i] && workDescriptions[i].length === 0"
                class="itFields"
                style="
                  width: 39.875rem;
                  background-color: #f3fafd;
                  padding-left: 0.5rem;
                  padding-right: 0.5rem;
                "
              >
                <input
                  type="text"
                  placeholder="Work Description"
                  matInput
                  [(ngModel)]="detail.workDescription"
                  readonly="true"
                  [name]="'laborDetail.workDescriptionField' + i"
                  [required]="isEmployeeContractorRequired()"
                />
              </mat-form-field>
              <mat-form-field
                [class.removeElement]="
                  workDescriptions[i] && workDescriptions[i].length === 0
                "
                class="itFields"
                style="
                  width: 39.875rem;
                  padding-left: 0.5rem;
                  padding-right: 0.5rem;
                "
              >
                <mat-select
                  [(ngModel)]="detail.workDescription"
                  placeholder="Work Description"
                  [required]="isEmployeeContractorRequired()"
                  [name]="'laborDetail.workDescriptionField' + i"
                >
                  <mat-option
                    *ngFor="let option of workDescriptions[i]"
                    style="color: #696969"
                    [value]="option"
                    ><span>{{ option }}</span></mat-option
                  >
                </mat-select>
              </mat-form-field>
            </div>
            <div
              style="
                display: inline-block;
                margin-top: 1.125rem;
                margin-left: 0.5rem;
              "
            >
              <mat-form-field
                class="itFields"
                style="width: 9rem; padding-left: 0.5rem; padding-right: 0.5rem"
              >
                <mat-select
                  [(ngModel)]="detail.chargeType"
                  placeholder="Charge Type"
                  [name]="'laborDetail.chargeTypeField' + i"
                  [required]="isEmployeeContractorRequired()"
                >
                  <mat-option
                    *ngFor="let option of chargeTypeOptions"
                    style="color: #696969"
                    [value]="option"
                    ><span>{{ option }}</span></mat-option
                  >
                </mat-select>
              </mat-form-field>
            </div>
            <div
              style="
                display: inline-block;
                margin-top: 1.125rem;
                margin-left: 0.438rem;
              "
            >
              <mat-form-field
                class="itFields"
                style="width: 6rem; padding-left: 0.5rem; padding-right: 0.5rem"
                [floatLabel]="'always'"
              >
                <input
                  appCurrencyMask
                  appNumbersOnly
                  [allowDecimals]="true"
                  onkeypress="return event.charCode != 45"
                  [(ngModel)]="detail.totalCosts"
                  placeholder="Total Costs"
                  matInput
                  [name]="'laborDetail.totalCostsField' + i"
                  [required]="isEmployeeContractorRequired()"
                />
                <span matPrefix>$</span>
              </mat-form-field>
            </div>
            <div
              style="
                display: inline-block;
                margin-top: 1.125rem;
                margin-right: 0.5rem;
              "
            >
              <img
                style="
                  cursor: pointer;
                  width: 1rem;
                  height: 1rem;
                  padding-left: 1rem;
                "
                src="assets/trash-bin-base.svg"
                (click)="deleteLaborDetail(i)"
              />
            </div>
          </div>
          <div style="width: 78rem; background-color: #f3fafd">
            <div
              style="
                padding-left: 1rem;
                padding-top: 1.188rem;
                padding-bottom: 1.313rem;
                cursor: pointer;
                width: 15rem;
              "
              (click)="addLaborDetail()"
            >
              <span style="font-weight: bold; font-size: 1.4rem">&#43;</span>
              <span
                style="
                  padding-left: 0.2rem;
                  text-decoration: underline;
                  text-underline-offset: 0.2rem;
                "
                >Add New Labor</span
              >
            </div>
            <div
              style="
                position: relative;
                float: right;
                margin-top: -4rem;
                margin-right: 3.6rem;
              "
            >
              <div>
                <span style="color: #696969">Total Estimated:</span>
              </div>
              <div>
                <span style="color: #696969; font-weight: bold"
                  >${{
                    laborTotal().toLocaleString("en", { useGrouping: true })
                  }}</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        style="
          padding-top: 1.5rem;
          width: 78rem;
          margin-top: 2.2rem;
          display: inline-block;
        "
      >
        <div style="width: 78rem; margin-bottom: 1.5rem; text-align: center">
          <span class="projectScopeHeader"
            >Contingency and Other Details (Optional)</span
          >
        </div>
        <div style="height: 0.1rem; background-color: #f5f5f5"></div>
      </div>
      <div
        *ngIf="!editFormMode"
        style="width: 78rem; height: 6.25rem; display: inline-block"
      >
        <div *ngFor="let detail of contingencyDetails; let i = index">
          <div
            style="
              display: inline-block;
              margin-top: 1.125rem;
              margin-left: 1.5rem;
            "
          >
            <mat-form-field class="itFields" style="width: 15rem">
              <input
                readonly="true"
                type="text"
                placeholder="Cost"
                matInput
                [(ngModel)]="detail.cost"
                [name]="'detailCost' + i"
              />
            </mat-form-field>
          </div>
          <div
            style="
              display: inline-block;
              margin-top: 1.125rem;
              margin-left: 0.5rem;
            "
          >
            <mat-form-field class="itFields" style="width: 47.15rem">
              <input
                readonly="true"
                [(ngModel)]="detail.description"
                placeholder="Description"
                matInput
                [name]="'detailDescription' + i"
              />
            </mat-form-field>
          </div>
          <div
            style="
              display: inline-block;
              margin-top: 1.125rem;
              margin-left: 0.438rem;
            "
          >
            <mat-form-field
              class="itFields"
              style="width: 6rem"
              [floatLabel]="'always'"
            >
              <input
                readonly="true"
                type="text"
                [value]="
                  +detail.totalCosts | CurrencyUSD : 'USD' : true : false
                "
                placeholder="Total Costs"
                matInput
              />
            </mat-form-field>
          </div>
        </div>
        <div style="width: 78rem; background-color: #f3fafd">
          <div style="position: relative; float: right; margin-right: 6rem">
            <div>
              <span style="color: #696969">Total Estimated:</span>
            </div>
            <div>
              <span style="color: #696969; font-weight: bold"
                >${{
                  contingencyTotal().toLocaleString("en", { useGrouping: true })
                }}</span
              >
            </div>
          </div>
        </div>
      </div>
      <div
        *ngIf="editFormMode"
        style="
          width: 78rem;
          height: 6.25rem;
          background-color: #f3fafd;
          display: inline-block;
        "
      >
        <div
          *ngFor="let detail of contingencyDetailsCopy; let i = index"
          style="background-color: #f3fafd"
        >
          <div
            style="
              display: inline-block;
              margin-top: 1.125rem;
              margin-left: 1.5rem;
            "
          >
            <mat-form-field
              class="itFields"
              style="width: 15rem; padding-left: 0.5rem; padding-right: 0.5rem"
            >
              <mat-select
                [(ngModel)]="detail.cost"
                placeholder="Cost"
                [name]="'contingencyDetail.costField' + i"
                [required]="isContingencyRowMissing(i, 'cost')"
              >
                <mat-option
                  *ngFor="let option of contingencyCostOptions"
                  style="color: #696969"
                  [value]="option"
                  ><span>{{ option }}</span></mat-option
                >
              </mat-select>
            </mat-form-field>
          </div>
          <div
            style="
              display: inline-block;
              margin-top: 1.125rem;
              margin-left: 0.5rem;
            "
          >
            <mat-form-field
              class="itFields"
              style="
                width: 47.15rem;
                padding-left: 0.5rem;
                padding-right: 0.5rem;
              "
            >
              <input
                [(ngModel)]="detail.description"
                placeholder="Description"
                matInput
                [name]="'contingencyDetail.descriptionField' + i"
                [required]="isContingencyRowMissing(i, 'description')"
              />
            </mat-form-field>
          </div>
          <div
            style="
              display: inline-block;
              margin-top: 1.125rem;
              margin-left: 0.438rem;
            "
          >
            <mat-form-field
              class="itFields"
              style="width: 6rem; padding-left: 0.5rem; padding-right: 0.5rem"
              [floatLabel]="'always'"
            >
              <input
                appCurrencyMask
                appNumbersOnly
                [allowDecimals]="true"
                onkeypress="return event.charCode != 45"
                [(ngModel)]="detail.totalCosts"
                placeholder="Total Costs"
                matInput
                [name]="'contingencyDetail.totalCostsField' + i"
                [required]="isContingencyRowMissing(i, 'totalCosts')"
              />
              <span matPrefix>$</span>
            </mat-form-field>
          </div>
          <div
            style="
              display: inline-block;
              margin-top: 1.125rem;
              margin-right: 0.5rem;
            "
          >
            <img
              style="
                cursor: pointer;
                width: 1rem;
                height: 1rem;
                padding-left: 1rem;
              "
              src="assets/trash-bin-base.svg"
              (click)="deleteContingencyDetail(i)"
            />
          </div>
        </div>
        <div style="width: 78rem; background-color: #f3fafd">
          <div
            style="
              padding-left: 1rem;
              padding-top: 1.188rem;
              padding-bottom: 1.313rem;
              cursor: pointer;
              width: 15rem;
            "
            (click)="addContingencyDetail()"
          >
            <span style="font-weight: bold; font-size: 1.4rem">&#43;</span>
            <span
              style="
                padding-left: 0.2rem;
                text-decoration: underline;
                text-underline-offset: 0.2rem;
              "
              >Add New Contingency/Other</span
            >
          </div>
          <div
            style="
              position: relative;
              float: right;
              margin-top: -4rem;
              margin-right: 3.6rem;
            "
          >
            <div>
              <span style="color: #696969">Total Estimated:</span>
            </div>
            <div>
              <span style="color: #696969; font-weight: bold"
                >${{
                  contingencyTotal().toLocaleString("en", { useGrouping: true })
                }}</span
              >
            </div>
          </div>
        </div>
      </div>

      <div
        style="
          padding-top: 1.5rem;
          width: 78rem;
          margin-top: 2.2rem;
          display: inline-block;
          padding-bottom: 1rem;
        "
      >
        <div style="width: 78rem; margin-bottom: 1.5rem; text-align: center">
          <div class="projectScopeHeader pb-1">Cost Summary</div>
          <div style="height: 0.1rem; background-color: #f5f5f5"></div>
        </div>

        <div class="cost-container mb-1 pb-1 grey-border-bottom">
          <div class="cost-column">Total Capital $ by Charge Type</div>
          <div class="cost-column"></div>
          <div class="cost-column">Total O&M $ by Charge Type</div>
          <div class="cost-column"></div>
          <div class="cost-column"></div>
          <div class="cost-column"></div>
        </div>

        <div class="cost-container">
          <div class="cost-column">Internal Labor</div>
          <div class="cost-column">
            <div class="cost">
              <div>$</div>
              <div>
                {{
                  internalCapital().toLocaleString("en", { useGrouping: true })
                }}
              </div>
            </div>
          </div>
          <div class="cost-column">Internal Labor</div>
          <div class="cost-column">
            <div class="cost">
              <div>$</div>
              <div>
                {{ internalOM().toLocaleString("en", { useGrouping: true }) }}
              </div>
            </div>
          </div>
          <div class="cost-column">Capital Cost</div>
          <div class="cost-column">
            <div class="cost">
              <div>$</div>
              <div>
                {{
                  subtotalCapital().toLocaleString("en", { useGrouping: true })
                }}
              </div>
            </div>
          </div>
        </div>

        <div class="cost-container">
          <div class="cost-column">External Labor</div>
          <div class="cost-column">
            <div class="cost">
              <div>$</div>
              <div>
                {{
                  externalCapital().toLocaleString("en", { useGrouping: true })
                }}
              </div>
            </div>
          </div>
          <div class="cost-column">External Labor</div>
          <div class="cost-column">
            <div class="cost">
              <div>$</div>
              <div>
                {{ externalOM().toLocaleString("en", { useGrouping: true }) }}
              </div>
            </div>
          </div>
          <div class="cost-column">Estimated AFUDC of Project</div>
          <div class="cost-column">
            <div class="cost">
              <div>$</div>
              <div>
                {{
                  estimatedAFUDC().toLocaleString("en", { useGrouping: true })
                }}
              </div>
            </div>
          </div>
        </div>

        <div class="cost-container">
          <div class="cost-column">Material</div>
          <div class="cost-column">
            <div class="cost">
              <div>$</div>
              <div>
                {{
                  materialCapital().toLocaleString("en", { useGrouping: true })
                }}
              </div>
            </div>
          </div>
          <div class="cost-column">Material</div>
          <div class="cost-column">
            <div class="cost">
              <div>$</div>
              <div>
                {{ materialOM().toLocaleString("en", { useGrouping: true }) }}
              </div>
            </div>
          </div>
          <div class="cost-column">Total Capital Cost</div>
          <div class="cost-column">
            <div class="cost">
              <div>$</div>
              <div>
                {{
                  totalCapitalCost().toLocaleString("en", { useGrouping: true })
                }}
              </div>
            </div>
          </div>
        </div>

        <div class="cost-container">
          <div class="cost-column">Contingency</div>
          <div class="cost-column">
            <div class="cost">
              <div>$</div>
              <div>
                {{
                  contingencyCapital().toLocaleString("en", {
                    useGrouping: true
                  })
                }}
              </div>
            </div>
          </div>
          <div class="cost-column">Contingency</div>
          <div class="cost-column">
            <div class="cost">
              <div>$</div>
              <div>
                {{
                  contingencyOM().toLocaleString("en", { useGrouping: true })
                }}
              </div>
            </div>
          </div>
          <div class="cost-column"></div>
          <div class="cost-column"></div>
        </div>

        <div class="cost-container">
          <div class="cost-column">Other</div>
          <div class="cost-column">
            <div class="cost">
              <div>$</div>
              <div>
                {{ otherCapital().toLocaleString("en", { useGrouping: true }) }}
              </div>
            </div>
          </div>
          <div class="cost-column">Other</div>
          <div class="cost-column">
            <div class="cost">
              <div>$</div>
              <div>
                {{ otherOM().toLocaleString("en", { useGrouping: true }) }}
              </div>
            </div>
          </div>
          <div class="cost-column"></div>
          <div class="cost-column"></div>
        </div>

        <div class="cost-container">
          <div class="cost-column">Subtotal</div>
          <div class="cost-column">
            <div class="cost">
              <div>$</div>
              <div>
                {{
                  subtotalCapital().toLocaleString("en", { useGrouping: true })
                }}
              </div>
            </div>
          </div>
          <div class="cost-column">Subtotal</div>
          <div class="cost-column">
            <div class="cost">
              <div>$</div>
              <div>
                {{ subtotalOM().toLocaleString("en", { useGrouping: true }) }}
              </div>
            </div>
          </div>
          <div class="cost-column">Total O&M Cost</div>
          <div class="cost-column">
            <div class="cost">
              <div>$</div>
              <div>
                {{ subtotalOM().toLocaleString("en", { useGrouping: true }) }}
              </div>
            </div>
          </div>
        </div>

        <div class="cost-container">
          <div class="cost-column">Subtotal This Request</div>
          <div class="cost-column">
            <div class="cost">
              <div>$</div>
              <div>
                {{
                  subtotalCapitalThisRequest().toLocaleString("en", {
                    useGrouping: true
                  })
                }}
              </div>
            </div>
          </div>
          <div class="cost-column">Subtotal This Request</div>
          <div class="cost-column">
            <div class="cost">
              <div>$</div>
              <div>
                {{
                  subtotalOMThisRequest().toLocaleString("en", {
                    useGrouping: true
                  })
                }}
              </div>
            </div>
          </div>
          <div class="cost-column">Total Cost (Including AFUDC)</div>
          <div class="cost-column">
            <div class="cost">
              <div>$</div>
              <div>
                {{
                  totalProjectCost().toLocaleString("en", { useGrouping: true })
                }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div style="margin-top: 1.5rem; margin-bottom: 0.5rem">
        <span class="projectScopeHeader"
          >Additional Comments to ITPAC (Optional)</span
        >
      </div>
      <div style="margin-top: 0.688rem">
        <div *ngIf="!editFormMode" class="p-1 grey-border text-grey width-60">
          {{ additionalComments }}
        </div>
        <textarea
          *ngIf="editFormMode"
          [(ngModel)]="additionalCommentsCopy"
          class="scopeDescriptionTextBox"
          style="border-color: rgb(38, 188, 215)"
          maxlength="255"
          name="additionalCommentsField"
        ></textarea>
      </div>
      <div *ngIf="editFormMode">
        <span
          style="
            color: #696969;
            font-style: italic;
            margin-right: 9.938rem;
            float: right;
          "
          >{{ additionalCommentLength() }} / 255 characters</span
        >
      </div>
      <div style="margin-top: 1.5rem; margin-bottom: 0.5rem">
        <span class="projectScopeHeader">Attachments</span>
      </div>
      <div style="margin-top: 0.5rem; margin-bottom: 0.5rem">
        <span class="projectScopeNonHeader"
          >Note: Files are for review purposes only. Files uploaded in MMAPS
          will <span style="font-style: italic; font-size: 0.9rem">not</span> be
          added to PowerPlan.</span
        >
      </div>
      <ng-container *ngIf="canEditForm() && editFormMode">
        <input
          type="file"
          style="display: none"
          (change)="onFileSelected($event)"
          #fileUpload
          multiple
        />
        <div
          (drop)="onDrop($event)"
          (dragover)="onDragOver($event)"
          style="
            width: 49.125rem;
            height: 4.063rem;
            border: 0.063rem solid #ccc;
            border-radius: 0.875rem;
          "
        >
          <div style="text-align: center; margin-top: 1.125rem">
            <img
              style="width: 1rem; height: 1rem; padding-left: 1rem"
              src="assets/attach-file.svg"
            />
            <span style="color: rgb(105, 105, 105)">Drop a file here or </span>
            <span style="cursor: pointer" (click)="fileUpload.click()"
              >browse to upload</span
            >
          </div>
        </div>
      </ng-container>
      <div
        *ngIf="filesCopy.length > 0"
        style="
          background-color: #f3fafd;
          padding-top: 1.5rem;
          width: 48.375rem;
          margin-top: 1.5rem;
          display: inline-block;
          padding-bottom: 1rem;
        "
      >
        <div style="margin-top: 1.5rem; margin-left: 1.5rem">
          <div style="display: inline-block">
            <span class="projectScopeSubHeader" style="font-size: 0.875rem"
              >File Name</span
            >
          </div>
          <div style="display: inline-block; margin-left: 15rem">
            <span class="projectScopeSubHeader" style="font-size: 0.875rem"
              >Added By</span
            >
          </div>
          <div style="display: inline-block; margin-left: 10rem">
            <span class="projectScopeSubHeader" style="font-size: 0.875rem"
              >Date</span
            >
          </div>
          <div
            style="
              display: inline-block;
              height: 0.1rem;
              background-color: #f5f5f5;
              margin-bottom: 0.5rem;
              width: 46rem;
            "
          ></div>
          <div *ngFor="let file of filesCopy; let i = index">
            <div style="display: inline-block; width: 19.05rem">
              <span class="projectScopeNonHeader" style="font-size: 0.875rem">{{
                file.fileName
              }}</span>
            </div>
            <div style="display: inline-block; width: 13.95rem">
              <span class="projectScopeNonHeader" style="font-size: 0.875rem">{{
                file.addedByName
              }}</span>
            </div>
            <div style="display: inline-block">
              <span class="projectScopeNonHeader" style="font-size: 0.875rem">{{
                file.date
              }}</span>
            </div>
            <div
              style="
                display: inline-block;
                margin-top: 1.125rem;
                margin-right: 0.5rem;
              "
            >
              <img
                style="
                  cursor: pointer;
                  width: 1rem;
                  height: 1rem;
                  padding-left: 3.5rem;
                "
                src="assets/file-download.svg"
                (click)="downloadFile(i)"
              />
            </div>
            <div
              *ngIf="canEditForm() && editFormMode"
              style="
                display: inline-block;
                margin-top: 1.125rem;
                margin-right: 0.5rem;
              "
            >
              <img
                style="
                  cursor: pointer;
                  width: 1rem;
                  height: 1rem;
                  padding-left: 1rem;
                "
                src="assets/trash-bin-base.svg"
                (click)="deleteFile(i)"
              />
            </div>
          </div>
        </div>
      </div>
      <div style="margin-top: 1.5rem; margin-bottom: 0.5rem">
        <span class="projectScopeHeader">Approvers</span>
      </div>
      <div style="padding-top: 1.5rem; width: 78rem; display: inline-block">
        <div style="margin-top: 1.5rem">
          <div style="display: inline-block; white-space: nowrap">
            <span class="projectScopeSubHeader" style="font-size: 0.875rem"
              >Name, Title</span
            >
          </div>
          <div
            style="
              display: inline-block;
              margin-left: 60.438rem;
              white-space: nowrap;
            "
          >
            <span class="projectScopeSubHeader" style="font-size: 0.875rem"
              >DOA Authority Amount</span
            >
          </div>
        </div>
        <div
          style="
            display: inline-block;
            height: 0.1rem;
            background-color: #f5f5f5;
            margin-bottom: 0.5rem;
            width: 75.625rem;
          "
        ></div>
        <div style="padding-bottom: 1.5rem">
          <div
            *ngIf="!editFormMode"
            style="display: inline-block; width: 65.125rem"
          >
            <span class="projectScopeSubHeader" style="font-size: 0.875rem"
              >{{ itSponsor.givenName }} {{ itSponsor.surname }}, Sponsor</span
            >
          </div>
          <div
            *ngIf="editFormMode"
            style="display: inline-block; width: 65.125rem"
          >
            <span class="projectScopeSubHeader" style="font-size: 0.875rem"
              >{{ itSponsorCopy.givenName }} {{ itSponsorCopy.surname }},
              Sponsor</span
            >
          </div>
          <div
            *ngIf="!editFormMode"
            style="display: inline-block; width: 4.125rem"
          >
            <span *ngIf="!doaLookupFailed[0] && !doaLookupLoading[0]" class="projectScopeSubHeader" style="font-size: 0.875rem"
              >${{
                doaAmounts[0].toLocaleString("en", { useGrouping: true })
              }}</span
            >
            <span
              *ngIf="doaLookupLoading[0]"
              style="color: #696969; font-size: 0.75rem;"
            >
              Checking DOA&hellip;
            </span>
            <span
              *ngIf="doaLookupFailed[0] && !doaLookupLoading[0]"
              style="color: #9e1b32; font-size: 0.75rem;"
            >
              DOA lookup failed
              <br />
              <a
                style="cursor: pointer; text-decoration: underline;"
                (click)="retryDoaLookup(0)"
                >Retry</a
              >
            </span>
          </div>
          <div
            *ngIf="editFormMode"
            style="display: inline-block; width: 4.125rem"
          >
            <span *ngIf="!doaLookupFailed[0] && !doaLookupLoading[0]" class="projectScopeSubHeader" style="font-size: 0.875rem"
              >${{
                doaAmountsCopy[0].toLocaleString("en", { useGrouping: true })
              }}</span
            >
            <span
              *ngIf="doaLookupLoading[0]"
              style="color: #696969; font-size: 0.75rem;"
            >
              Checking DOA&hellip;
            </span>
            <span
              *ngIf="doaLookupFailed[0] && !doaLookupLoading[0]"
              style="color: #9e1b32; font-size: 0.75rem;"
            >
              DOA lookup failed
              <br />
              <a
                style="cursor: pointer; text-decoration: underline;"
                (click)="retryDoaLookup(0)"
                >Retry</a
              >
            </span>
          </div>
        </div>
        <div
          *ngFor="let approver of approverList; let i = index"
          style="padding-bottom: 1.5rem"
        >
          <div style="display: inline-block; width: 65.125rem">
            <span
              class="projectScopeSubHeader"
              style="font-size: 0.875rem"
              *ngIf="
                approver.givenName && approver.surname && approver.jobTitle
              "
              >{{ approver.givenName }} {{ approver.surname }} ({{
                approver.mail
              }}), {{ approver.jobTitle }}</span
            >
            <span
              class="projectScopeSubHeader"
              style="font-size: 0.875rem"
              *ngIf="
                approver.givenName && approver.surname && !approver.jobTitle
              "
              >{{ approver.givenName }} {{ approver.surname }} ({{
                approver.mail
              }})</span
            >
            <span
              class="projectScopeSubHeader"
              style="font-size: 0.875rem"
              *ngIf="
                !(approver.givenName && approver.surname) && approver.jobTitle
              "
              >{{ approver.displayName }} ({{ approver.mail }}),
              {{ approver.jobTitle }}</span
            >
            <span
              class="projectScopeSubHeader"
              style="font-size: 0.875rem"
              *ngIf="
                !(approver.givenName && approver.surname) && !approver.jobTitle
              "
              >{{ approver.displayName }} ({{ approver.mail }})</span
            >
          </div>
          <div style="display: inline-block; width: 4.125rem">
            <span class="projectScopeSubHeader" style="font-size: 0.875rem"
              >${{
                ((editFormMode ? doaAmountsCopy[i + 1] : doaAmounts[i + 1]) || 0).toLocaleString("en", { useGrouping: true })
              }}</span
            >
          </div>
          <div
            *ngIf="editFormMode && canEditForm()"
            style="display: inline-block; vertical-align: middle"
          >
            <img
              style="
                cursor: pointer;
                width: 1rem;
                height: 1rem;
                padding-left: 3.5rem;
              "
              src="assets/trash-bin-base.svg"
              title="Remove approver"
              (click)="removeApprover(i)"
            />
          </div>
        </div>
        <div
          *ngIf="editFormMode && canEditForm()"
          style="
            padding-top: 0.5rem;
            padding-bottom: 1.313rem;
            cursor: pointer;
            width: 15rem;
          "
          (click)="launchApproverDialog(true)"
        >
          <span style="font-weight: bold; font-size: 1.4rem">&#43;</span>
          <span
            style="
              padding-left: 0.2rem;
              text-decoration: underline;
              text-underline-offset: 0.2rem;
            "
            >Add Another Approver</span
          >
        </div>
      </div>
    </form>

    <div
      style="
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        width: 78rem;
      "
    >
      <div style="margin-top: 2.625rem">
        <span class="itProjectHeader" style="font-size: 1.313rem"
          >Derivations and Allocations</span
        >
        <div style="margin-top: 1.5rem; margin-bottom: 0.5rem">
          <span class="projectScopeHeader">Form-Level Derivations</span>
          <div style="margin-top: 1.5rem; margin-bottom: 0.5rem"></div>
          <div class="form-container">
            <div
              class="form-column-header grey-border-bottom"
              style="width: 15rem !important; margin-right: 5rem"
            >
              Project Manager
            </div>
            <div
              class="form-column-header grey-border-bottom"
              style="width: 15rem !important; margin-right: 5rem"
            >
              Engineer
            </div>
            <div
              class="form-column-header grey-border-bottom"
              style="width: 15rem !important; margin-right: 5rem"
            >
              Contract Admin
            </div>
          </div>
          <div class="form-container">
            <div
              class="form-column-text"
              style="width: 20rem !important"
              *ngIf="derivationAndAllocations.projectManager"
            >
              {{ derivationAndAllocations.projectManager }}
            </div>
            <div
              class="form-column-text"
              style="width: 20rem !important"
              *ngIf="derivationAndAllocations.engineer"
            >
              {{ derivationAndAllocations.engineer }}
            </div>

            <div
              class="form-column-text"
              style="width: 20rem !important"
              *ngIf="derivationAndAllocations.contractAdmin"
            >
              {{ derivationAndAllocations.contractAdmin }}
            </div>
          </div>
          <div style="margin-top: 1.5rem; margin-bottom: 0.5rem">
            <span class="projectScopeHeader">Project Notes:</span>
          </div>
          <div style="margin-top: 0.688rem">
            <div
              *ngIf="!editFormMode"
              class="p-1 grey-border text-grey width-60"
            >
              {{ getProjectNotes() }}
            </div>
          </div>
        </div>
        <div style="margin-top: 1.5rem; margin-bottom: 1rem">
          <span class="projectScopeHeader">Project Specific Derivations</span>
          <div style="height: 0.5rem; padding-bottom: 5px"></div>
          <div>
            <div class="form-container grey-border-bottom" style="width: 82rem">
              <div class="form-column-header" style="width: 3rem !important">
                BU
              </div>
              <div class="form-column-header" style="width: 6rem !important">
                Project
              </div>
              <div class="form-column-header" style="width: 15rem !important">
                Major Location
              </div>
              <div class="form-column-header" style="width: 18rem !important">
                Asset Location
              </div>
              <div class="form-column-header" style="width: 18rem !important">
                Project Type
              </div>
              <div class="form-column-header" style="width: 7rem !important">
                Project Charge Indicator
              </div>
              <div class="form-column-header" style="width: 7rem !important">
                Joint Owner Code
              </div>
            </div>

            <div class="form-container" *ngFor="let project of itProjects">
              <div class="form-column-text" style="width: 3rem !important">
                {{ project.businessUnit }}
              </div>
              <div class="form-column-text" style="width: 6rem !important">
                {{ project.projectID }}
              </div>
              <div *ngIf="project.majorLocation" class="form-column-text" style="width: 15rem !important">
                {{ project.majorLocation }}
              </div>
              <div *ngIf="!project.majorLocation" class="form-column-text" style="width: 15rem !important; color: darkred">
                Value could not be derived - Correct before proceeding
              </div>
              <div *ngIf="project.assetLocation" class="form-column-text" style="width: 18rem !important">
                {{ project.assetLocation }}
              </div>
              <div *ngIf="!project.assetLocation" class="form-column-text" style="width: 18rem !important; color: darkred">
                Value could not be derived - Correct before proceeding
              </div>
              <div class="form-column-text" style="width: 18rem !important">
                {{ project.projectType }}
              </div>
              <div class="form-column-text" style="width: 7rem !important">
                {{ project.projectChargeIndicator }}
              </div>
              <div
                class="form-column-text"
                style="width: 7rem !important"
                *ngIf="project.projectID.endsWith('C')"
              >
                CJOBASIC
              </div>
            </div>
            <div style="height: 1rem; width: 50rem"></div>
            <span class="projectScopeHeader">Activities</span>
            <div style="height: 0.5rem; padding-bottom: 5px"></div>
            <div
              class="form-container grey-border-bottom"
              style="width: 40rem; margin-left: 0"
            >
              <div class="form-column-header" style="width: 3rem !important">
                BU
              </div>
              <div class="form-column-header" style="width: 6rem !important">
                Project
              </div>
              <div class="form-column-header" style="width: 10rem !important">
                Activity
              </div>
              <div class="form-column-header" style="width: 10rem !important">
                Description
              </div>
              <div class="form-column-header" style="width: 10rem !important">
                Accounting Model
              </div>
            </div>
            <div *ngFor="let project of itProjects">
              <ng-container *ngIf="project.activities.length > 0">
                <div
                  *ngFor="let activity of project.activities; let i = index"
                  class="form-container"
                  [ngStyle]="{
                    'margin-top':
                      i === 0 ||
                      project.activities[i - 1]?.businessUnit !==
                        activity.businessUnit
                        ? '1rem'
                        : '0'
                  }"
                  style="width: 40rem; margin-left: 0"
                >
                  <div class="form-column-text" style="width: 3rem !important">
                    {{ project.businessUnit }}
                  </div>
                  <div class="form-column-text" style="width: 6rem !important">
                    {{ project.projectID }}
                  </div>
                  <div class="form-column-text" style="width: 10rem !important">
                    {{ activity.activity }}
                  </div>
                  <div class="form-column-text" style="width: 10rem !important">
                    {{ activity.activityDescription }}
                  </div>
                  <div
                    *ngIf="activity.accountingModel"
                    class="form-column-text"
                    style="width: 10rem !important"
                  >
                    {{ activity.accountingModel }}
                  </div>
                  <div
                    *ngIf="!activity.accountingModel"
                    class="form-column-text"
                    style="width: 34rem !important; color: darkred"
                  >
                    Activity must be set up manually due to lack of an
                    appropriate acctg model.
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
          <div style="margin-top: 1.5rem; margin-bottom: 0.5rem">
            <span class="projectScopeHeader">Project Estimates</span>
            <div style="height: 0.1rem; background-color: #f5f5f5"></div>
            <ng-container *ngFor="let project of itProjects">
              <div class="gray-box">
                <span>
                  <span class="static-form-text">BU:</span>
                  <span class="dynamic-form-text">{{
                    project.businessUnit
                  }}</span>
                  <span class="static-form-text">Project:</span>
                  <span class="dynamic-form-text">{{ project.projectID }}</span>
                  <span class="static-form-text">Funding Project:</span>
                  <span class="dynamic-form-text">{{
                    project.fundingProjectID
                  }}</span>
                  <span class="static-form-text">Percent:</span>
                  <span class="dynamic-form-text">{{
                    project.fundingProjectPercent
                  }}</span>
                </span>
              </div>
              <ng-container *ngIf="project.groupedEstimates">
                <div *ngFor="let group of project.groupedEstimates">
                  <div class="transparent-box">
                    <span>
                      <span class="static-form-text">Major Location:</span>
                      <span *ngIf="group.majorLocation" class="dynamic-form-text">
                        {{ group.majorLocation }}</span
                      >
                      <span *ngIf="!group.majorLocation" class="dynamic-form-text" style="color: darkred">
                        Value could not be derived - Correct before proceeding</span
                      >
                      <span class="static-form-text">Asset Location:</span>
                      <span *ngIf="group.assetLocation" class="dynamic-form-text">
                        {{ group.assetLocation }}</span
                      >
                    </span>
                    <span *ngIf="!group.assetLocation" class="dynamic-form-text" style="color: darkred">
                      Value could not be derived - Correct before proceeding</span
                    >
                    <div
                      class="form-container grey-border-bottom"
                      style="margin-top: 1rem"
                    >
                      <div
                        class="form-column-header"
                        style="width: 20rem !important"
                      >
                        Utility Account
                      </div>
                      <div
                        class="form-column-header"
                        style="width: 20rem !important"
                      >
                        Retirement Unit
                      </div>
                      <div
                        class="form-column-header"
                        style="width: 10rem !important"
                      >
                        Expenditure Type
                      </div>
                      <div
                        class="form-column-header"
                        style="width: 10rem !important"
                      >
                        Charge Type
                      </div>
                      <div
                        class="form-column-header"
                        style="
                          width: 10rem !important;
                          text-align: right !important;
                        "
                      >
                        Total Cost
                      </div>
                    </div>
                    <div
                      class="form-container"
                      *ngFor="let estimate of group.values"
                    >
                      <div
                        class="form-column-text"
                        style="width: 20rem !important"
                      >
                        <span *ngIf="estimate.utilityAccountDescription">
                          {{ estimate.utilityAccountDescription }}
                        </span>
                        <span *ngIf="
                          !estimate.utilityAccountDescription &&
                          estimate.estimateType.includes('O&M')
                        ">
                          N/A
                        </span>
                      </div>
                      <div
                        class="form-column-text"
                        style="width: 20rem !important"
                      >
                        <span *ngIf="estimate.retirementUnitDescription">
                          {{ estimate.retirementUnitDescription }}
                        </span>
                        <span *ngIf="
                          !estimate.retirementUnitDescription &&
                          estimate.estimateType.includes('O&M')
                        ">
                          N/A
                        </span>
                      </div>
                      <div
                        class="form-column-text"
                        style="width: 10rem !important"
                      >
                        <span *ngIf="
                          estimate.estimateType.includes('CAP') ||
                          estimate.estimateType.includes('AFUDC')
                        ">
                          Addition
                        </span>
                        <span *ngIf="estimate.estimateType.includes('Removal')">
                          Retirement
                        </span>
                        <span *ngIf="estimate.estimateType.includes('O&M')">
                          Expense
                        </span>
                        <span *ngIf="
                          !estimate.estimateType.includes('O&M') &&
                          !estimate.estimateType.includes('Removal') &&
                          !estimate.estimateType.includes('CAP') &&
                          !estimate.estimateType.includes('AFUDC')
                        ">
                          N/A
                        </span>
                      </div>
                      <div
                        class="form-column-text"
                        style="width: 10rem !important"
                      >
                        {{ estimate.estimateType }}
                      </div>
                      <div
                        class="form-column-cost"
                        style="width: 10rem; text-align: right !important"
                      >
                        ${{
                          estimate.dollarAmount.toLocaleString("en", {
                            useGrouping: true
                          })
                        }}
                      </div>
                    </div>
                    <div class="form-container location-total-row">
                      <div
                        class="static-form-text"
                        style="
                          width: 20rem !important;
                          text-align: right;
                          font-weight: 700;
                        "
                      >
                        Location Total:
                      </div>
                      <div
                        class="form-column-cost"
                        style="
                          width: 13rem !important;
                          padding-right: 30px;
                          font-weight: 700;
                        "
                      >
                        ${{
                          group.locationCost.toLocaleString("en", {
                            useGrouping: true
                          })
                        }}
                      </div>
                    </div>
                  </div>
                </div>
              </ng-container>
              <div class="location-total-row transparent-box">
                <div
                  class="static-form-text"
                  style="
                    width: 20rem !important;
                    text-align: right;
                    font-weight: 800;
                  "
                >
                  Project Total:
                </div>
                <div
                  *ngIf="project.totalProjectCost"
                  class="form-column-cost"
                  style="
                    width: 13.75rem !important;
                    padding-right: 30px;
                    font-weight: 800;
                  "
                >
                  ${{
                    project.totalProjectCost.toLocaleString("en", {
                      useGrouping: true
                    })
                  }}
                </div>
              </div>
            </ng-container>
            <div class="location-total-row transparent-box">
              <div
                class="static-form-text"
                style="
                  width: 20rem !important;
                  text-align: right;
                  font-weight: 900;
                "
              >
                Grand Total:
              </div>
              <div
                class="form-column-cost"
                style="
                  width: 14rem !important;
                  padding-right: 30px;
                  font-weight: 900;
                "
              >
                ${{
                  getGrandTotalCost().toLocaleString("en", {
                    useGrouping: true
                  })
                }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div
    *ngIf="formActivityVisible"
    style="
      top: 0rem;
      right: 0rem;
      background-color: #f5f6f6;
      height: auto;
      box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
      z-index: 1000;
      position: absolute;
      width: 30%;
      padding: 0rem
    "
  >
    <div style="margin-left: 1.5rem; margin-top: 1.5rem">
      <div
        style="
          text-align: right;
          margin-bottom: -1.375rem;
          margin-right: 1.438rem;
        "
      >
        <span (click)="toggleFormActivity()" class="closeButton">&#10005;</span>
      </div>
      <div *ngIf="readyForReview()" style="margin-bottom: 1rem">
        <span style="font-size: 1.125rem; color: #4c4c4c"
          >The form is ready for your review.</span
        >
      </div>
      <div *ngIf="beingReviewed()" style="margin-bottom: 1rem">
        <span style="font-size: 1.125rem; color: #4c4c4c"
          >The form is being reviewed.</span
        >
      </div>
      <div *ngIf="youRejectedForm()" style="margin-bottom: 1rem">
        <span style="font-size: 1.125rem; color: #4c4c4c"
          >You have rejected the form.</span
        >
      </div>
      <div *ngIf="formRejected()" style="margin-bottom: 1rem">
        <span style="font-size: 1.125rem; color: #4c4c4c"
          >The form has been rejected.</span
        >
      </div>
      <div *ngIf="youApprovedForm()" style="margin-bottom: 1rem">
        <span style="font-size: 1.125rem; color: #4c4c4c"
          >You have approved the form.</span
        >
      </div>
      <div *ngIf="readyForCompletion()" style="margin-bottom: 1rem">
        <span style="font-size: 1.125rem; color: #4c4c4c"
          >The form is approved and ready to be completed.</span
        >
      </div>
      <div *ngIf="youCompleted()" style="margin-bottom: 1rem">
        <span style="font-size: 1.125rem; color: #4c4c4c"
          >You have completed the form.</span
        >
      </div>
      <div *ngIf="formCompleted()" style="margin-bottom: 1rem">
        <span style="font-size: 1.125rem; color: #4c4c4c"
          >The form has been completed.</span
        >
      </div>
      <div
        *ngIf="awaitingJointOwner()"
        style="margin-bottom: 1rem; width: 22.5rem"
      >
        <span style="font-size: 1.125rem; color: #4c4c4c"
          >The form is awaiting Joint Owner approval. You may add charging
          details for approved projects.</span
        >
      </div>
      <div
        *ngIf="formCompletedSpecial"
        style="margin-bottom: 1rem; width: 22.5rem"
      >
        <span style="font-size: 1.125rem; color: #4c4c4c"
          >The form has been completed. Please see special notes.</span
        >
      </div>
      <div
        *ngIf="rejectedNeedingEdits()"
        style="margin-bottom: 1rem; width: 22.5rem"
      >
        <span style="font-size: 1.125rem; color: #4c4c4c"
          >The form has been rejected. Edit the form, save your changes and then
          resubmit it for review.</span
        >
      </div>
      <div
        *ngIf="formResubmitted()"
        style="margin-bottom: 1rem; width: 22.5rem"
      >
        <span style="font-size: 1.125rem; color: #4c4c4c"
          >The form has been resubmitted for review.</span
        >
      </div>
      <div *ngIf="readyForReview() || rejectedNeedingEdits()">
        <textarea
          [(ngModel)]="reviewComments"
          class="scopeDescriptionTextBox2"
          placeholder="Comments (optional)"
        ></textarea>
      </div>
      <div
        *ngIf="readyForReview()"
        style="
          display: inline-block;
          padding-bottom: 1.5rem;
          margin-top: 1.25rem;
        "
      >
        <button (click)="approveForm(true)" class="rejectButton">
          <span class="confirmText">REJECT</span>
        </button>
      </div>
      <div
        *ngIf="readyForReview()"
        style="display: inline-block; padding-bottom: 1.5rem"
      >
        <button (click)="approveForm()" class="confirmButton" [class.buttonDisabled]="showDerivationError">
          <span class="confirmText">APPROVE</span>
        </button>
      </div>
      <div
        *ngIf="readyForCompletion() && isCurrentApprover()"
        style="display: inline-block; padding-bottom: 1.5rem"
      >
        <button
          (click)="openChargingDetailsDialog(true)"
          class="confirmButton"
          style="width: 24rem"
        >
          <span class="confirmText">COMPLETE THE FORM</span>
        </button>
      </div>
      <div
        *ngIf="rejectedNeedingEdits()"
        style="display: inline-block; padding-bottom: 1.5rem"
      >
        <button
          (click)="
            approveForm(
              false,
              true,
              true,
              projectSetupForm,
              projectEstimateForm
            )
          "
          class="confirmButton"
          style="width: 24rem"
        >
          <span class="confirmText">RESUBMIT</span>
        </button>
      </div>
      <div
        *ngIf="awaitingJointOwner()"
        style="display: inline-block; padding-bottom: 1.5rem"
      >
        <button
          (click)="openChargingDetailsDialog()"
          class="confirmButton"
          style="width: 24rem"
        >
          <span class="confirmText">ADD CHARGING DETAILS</span>
        </button>
      </div>
      <div
        style="height: 0.1rem; background-color: #b7b9ba; width: 25rem"
      ></div>
      <div style="margin-bottom: 1rem; margin-top: 1.5rem">
        <span style="font-size: 1.125rem; color: #4c4c4c">Form Activity</span>
      </div>
      <div
        *ngFor="let activity of formActivity"
        style="
          background-color: #ffffff;
          width: 24.062rem;
          padding-top: 0.875rem;
          padding-left: 0.938rem;
          margin-bottom: 1rem;
        "
      >
        <div style="display: inline-block">
          <span style="color: #4c4c4c">{{ activity.name }}</span>
        </div>
        <div
          style="display: inline-block; float: right; padding-right: 1.313rem"
        >
          <span
            *ngIf="activity.action === 'Submitted'"
            style="color: #4c4c4c"
            >{{ activity.action }}</span
          >
          <span *ngIf="activity.action === 'Approved'" style="color: #00853f">{{
            activity.action
          }}</span>
          <img
            *ngIf="activity.action === 'Approved'"
            style="width: 1.063rem; margin-left: 0.313rem"
            src="assets/approved.svg"
          />
          <span *ngIf="activity.action === 'Rejected'" style="color: #9e1b32">{{
            activity.action
          }}</span>
          <img
            *ngIf="activity.action === 'Rejected'"
            style="width: 1.063rem; margin-left: 0.313rem"
            src="assets/rejected.svg"
          />
          <span
            *ngIf="activity.action === 'Completed'"
            style="color: #4c4c4c"
            >{{ activity.action }}</span
          >
          <img
            *ngIf="activity.action === 'Completed'"
            style="width: 1.063rem; margin-left: 0.313rem"
            src="assets/completed.svg"
          />
          <span
            *ngIf="activity.action === 'Added Charging Details'"
            style="color: #4c4c4c; font-size: 0.875rem"
            >{{ activity.action }}</span
          >
          <span
            *ngIf="activity.action === 'Made a Change'"
            style="color: #4c4c4c; font-size: 0.875rem"
            >{{ activity.action }}</span
          >
          <span
            *ngIf="activity.action === 'Resubmitted'"
            style="color: #4c4c4c"
            >{{ activity.action }}</span
          >
        </div>
        <div>
          <span style="color: #696969; font-size: 0.875rem">
            <span *ngIf="activity.status">
              <span *ngIf="activity.status === 'ET&S PAC Review'">
                <span style="font-weight: bold">ITPAC Review</span> -
              </span>
              <span *ngIf="activity.status === 'Lead ET&S PAC Review'">
                <span style="font-weight: bold">Lead ITPAC Review</span> -
              </span>
              <span *ngIf="activity.status === 'IT Sponsor Review'">
                <span style="font-weight: bold">Sponsor Review</span> -
              </span>
              <span *ngIf="activity.status.startsWith('DOA Review')">
                <span style="font-weight: bold">DOA Review</span> -
              </span>
              <span
                *ngIf="
                  !(
                    activity.status === 'ET&S PAC Review' ||
                    activity.status === 'Lead ET&S PAC Review' ||
                    activity.status === 'IT Sponsor Review' ||
                    activity.status.startsWith('DOA Review')
                  )
                "
              >
                <span style="font-weight: bold">{{ activity.status }}</span> -
              </span> </span
            >{{ activity.time }}, {{ activity.day }}</span
          >
        </div>
        <div style="width: 95%; padding-bottom: 1rem">
          <span style="color: #4c4c4c; font-size: 0.875rem">{{
            activity.comment
          }}</span>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Email Templates -->

<!-- Charging Details Email Template -->
<div id="email_template_charging_email" class="email_templates">
  <div style="margin: auto; text-align: center; width: 42.75rem">
    <div style="text-align: left">
      <span style="font-size: 0.875rem"> $firstName </span>
    </div>
  </div>
  <p style="font-size: 0.875rem">
    Charging details have been added for
    <a href="$redirectUrl" style="font-size: 0.875rem">$formInfo</a>.
  </p>

  <p style="font-weight: bold; font-size: 14px">
    Effective Date $effectiveDate
  </p>

  <section>
    <div
      *ngFor="let table of tables; let tableIndex = index"
      style="margin-bottom: 20px"
    >
      <span style="font-weight: bold; font-size: 14px">{{
        table.tableName
      }}</span>

      <div>
        <table
          style="
            border: 1px solid #696969;
            border-collapse: collapse;
            width: fit-content;
          "
        >
          <th
            *ngFor="
              let column of getColumnDefs(tableIndex);
              let columnIndex = index
            "
            style="
              padding: 0px;
              border-width: 1px;
              border-style: inset;
              width: 200px;
              height: 54px;
              font-size: 16px;
              color: #696969;
              text-align: center;
              vertical-align: middle;
              font-weight: bold;
            "
          >
            {{ table.columns[columnIndex].colName }}
          </th>

          <tr *ngFor="let row of table.tableData; let rowIndex = index">
            <ng-container
              *ngFor="
                let column of getColumnDefs(tableIndex);
                let columnIndex = index
              "
            >
              <td
                style="
                  padding: 0px;
                  border-width: 1px;
                  border-style: inset;
                  width: 200px;
                  height: 48px;
                  font-size: 16px;
                  color: #696969;
                  text-align: center;
                  vertical-align: middle;
                "
              >
                {{ getRowValue(tableIndex, rowIndex, columnIndex) }}
              </td>
            </ng-container>
          </tr>
        </table>
      </div>
    </div>
  </section>

  <p style="font-size: 0.875rem">
    Please click below to view the charging details on the form.
  </p>

  <div style="margin: auto; text-align: center">
    <a href="$redirectUrl">
      <span
        style="
          width: 300px;
          background: rgb(0, 120, 158);
          border-radius: 0.125rem;
          display: inline-block;
          cursor: pointer;
          color: white;
          text-decoration: none;
          text-align: center;
          padding-top: 10px;
          padding-bottom: 10px;
        "
      >
        VIEW THE FORM
      </span>
    </a>
  </div>
</div>

<!-- Form Completed Email Template -->
<div id="email_template_form_completed" class="email_templates">
  <div style="margin: auto; text-align: center; width: 42.75rem">
    <div style="text-align: left">
      <span style="font-size: 0.875rem"> $firstName </span>
    </div>
  </div>
  <p style="font-size: 0.875rem">
    The <a href="$redirectUrl" style="font-size: 0.875rem">$formInfo</a> has
    been completed. See below for more information.
  </p>

  <p style="font-weight: bold; font-size: 14px">
    Effective Date $effectiveDate
  </p>

  <section>
    <div
      *ngFor="let table of tables; let tableIndex = index"
      style="margin-bottom: 20px"
    >
      <span style="font-weight: bold; font-size: 14px">{{
        table.tableName
      }}</span>

      <div>
        <table
          style="
            border: 1px solid #696969;
            border-collapse: collapse;
            width: fit-content;
          "
        >
          <th
            *ngFor="
              let column of getColumnDefs(tableIndex);
              let columnIndex = index
            "
            style="
              padding: 0px;
              border-width: 1px;
              border-style: inset;
              width: 200px;
              height: 54px;
              font-size: 16px;
              color: #696969;
              text-align: center;
              vertical-align: middle;
              font-weight: bold;
            "
          >
            {{ table.columns[columnIndex].colName }}
          </th>

          <tr *ngFor="let row of table.tableData; let rowIndex = index">
            <ng-container
              *ngFor="
                let column of getColumnDefs(tableIndex);
                let columnIndex = index
              "
            >
              <td
                style="
                  padding: 0px;
                  border-width: 1px;
                  border-style: inset;
                  width: 200px;
                  height: 48px;
                  font-size: 16px;
                  color: #696969;
                  text-align: center;
                  vertical-align: middle;
                "
              >
                {{ getRowValue(tableIndex, rowIndex, columnIndex) }}
              </td>
            </ng-container>
          </tr>
        </table>
      </div>
    </div>
  </section>

  <p style="font-weight: bold; font-size: 14px">Comments</p>
  <p style="font-weight: bold; font-size: 14px">$comments</p>

  <p style="font-size: 0.875rem">
    Please click below to view the charging details on the form.
  </p>

  <div style="margin: auto; text-align: center">
    <a href="$redirectUrl">
      <span
        style="
          width: 300px;
          background: rgb(0, 120, 158);
          border-radius: 0.125rem;
          display: inline-block;
          cursor: pointer;
          color: white;
          text-decoration: none;
          text-align: center;
          padding-top: 10px;
          padding-bottom: 10px;
        "
      >
        VIEW THE FORM
      </span>
    </a>
  </div>
</div>
